<template>
  <div style="margin: 0 auto; max-width: 1200px; width: 100%">
    <div v-if="showLoader" class="loader-wrapper">
      <div class="loader"></div>
    </div>

    <!-- Global modal used when pasting a file with Ctrl+V and no specific field is selected -->
    <b-modal 
      v-model="showPasteModal" 
      title="Paste File to Field" 
      hide-footer 
      size="lg"
      centered
    >
      <div v-if="clipboardFile" class="paste-modal-content">
        <div class="mb-3">
          <p class="mb-2 text-black">
            Select a file field to paste your file:
          </p>
          <div class="file-info-box mb-3">
            <small><strong>File:</strong> {{ clipboardFile.name }} ({{ formatFileSize(clipboardFile.size) }})</small>
          </div>
        </div>
        <div v-if="fileFieldsByProduct.length" class="accordion paste-modal-accordion" role="tablist">
          <div 
            v-for="(productGroup, index) in fileFieldsByProduct" 
            :key="`product-${index}`" 
            class="card mb-2"
          >
            <div 
              class="card-header paste-accordion-header" 
              role="tab" 
              :id="`heading-${index}`"
            >
              <h5 class="mb-0">
                <button
                  class="btn btn-link btn-block text-left text-decoration-none p-0 text-black"
                  @click="productGroup.isOpen = !productGroup.isOpen"
                  type="button"
                  :aria-expanded="productGroup.isOpen"
                  :aria-controls="`collapse-${index}`"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <div>
                      <strong>Product {{ index + 1 }}:</strong> 
                      <span>{{ productGroup.productName || 'Unnamed Product' }}</span>
                      <small class="ml-2 text-muted">({{ productGroup.fields.length }} fields)</small>
                    </div>
                    <span 
                      class="arrow-icon"
                      :class="{ 'arrow-down': productGroup.isOpen, 'arrow-right': !productGroup.isOpen }"
                    >→</span>
                  </div>
                </button>
              </h5>
            </div>
            <div
              :id="`collapse-${index}`"
              class="collapse"
              :class="{ show: productGroup.isOpen }"
              role="tabpanel"
              :aria-labelledby="`heading-${index}`"
            >
              <div class="card-body paste-card-body">
                <div class="row">
                  <div 
                    v-for="field in productGroup.fields"
                    :key="field.ref"
                    class="col-12 col-md-6 mb-2"
                  >
                    <button
                      class="btn btn-block text-left paste-field-btn"
                      @click="pasteFileToField(field.ref)"
                    >
                      {{ field.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="alert alert-warning">
          No file fields available.
        </div>
      </div>
      <div v-else class="text-center py-4">
        <p class="text-black">No file detected in clipboard.</p>
      </div>
    </b-modal>
    <template v-if="order_data">
      <template v-for="(orderItem, orderItemIndex) in order_data.items">
        <div v-for="(factory_product, factory_product_index) in orderItem.factory_products" :key="factory_product.id">
          
          <div >
            <table class="page fixed-table w-100-no-padding" :key="`factory-product-${factory_product.id}`">
              <tbody>
                <tr>
                  <th width="15%"></th>
                  <th width="25%"></th>
                  <th></th>
                  <th width="15%" class="text-right">
                    Page <span class="page_count"></span>                    
                  </th>
                </tr>

                <tr v-if="orderItemIndex == 0 && factory_product_index == 0">
                  <td colspan="4">
                    <table class="fixed-table order-details w-100">
                      <tbody>
                        <tr>
                          <td
                            class="w-50 v-align-top"
                            style="padding-right: 5pt"
                          >
                            <table class="table-fixed table-border w-100">
                              <tbody>
                                <tr>
                                  <td class="w-35 bg-gray-light">Order date</td>
                                  <td class="w-65">
                                    {{
                                    order_data.created_at
                                    | moment("DD/MM/YYYY")
                                    }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="w-35 bg-gray-light">
                                    Reference number
                                  </td>
                                  <td class="w-65">
                                     <input type="text" class="form-control"
                                      v-model="order_data.customer_reference_no"
                                      placeholder="Enter customer reference number" />
                                  </td>
                                </tr>
                                <tr>
                                  <td class="w-35 bg-gray-light">
                                    Factory PO number
                                  </td>
                                  <td class="w-65">
                                    <input type="text" class="form-control"
                                      v-model="order_data.additional_fields.po_number"
                                      placeholder="Enter PO number" />
                                  </td>
                                </tr>
                                  <tr>
                                  <td class="w-35 bg-gray-light">
                                    Merchant name
                                  </td>
                                  <td class="w-65" v-if="$can('update-merchant-from-techpack')">
                                   <v-select
                                      v-model="order_data.company_id"
                                      :options="companies"
                                      :reduce="company => company.id"
                                      label="company_name"
                                      :clearable="false"
                                      placeholder="Select Company"
                                      @input="handleCompanyChange"
                                    />
                                    
                                  </td>
                                  <td class="w-65" v-else>
                                    {{
                                      order_data.company_name
                                      ? order_data.company_name
                                      : ""
                                    }} 
                                  </td>
                                
                                </tr>
                                <tr v-if="customers.length">
                                  <td class="w-35 bg-gray-light">Customer name</td>

                                  <td class="w-65" v-if="$can('update-merchant-from-techpack')">
                               
                                   <v-select
                                      v-model="order_data.customer_id"
                                      :options="customers"
                                      :reduce="c => c.id"
                                      label="name"
                                      :clearable="false"
                                      placeholder="Select Customer"
                                      @input="handleCustomerChange"
                                      v-validate="{ required: true }"
                                    />
                                   
                                  </td>
                                   <td class="w-65" v-else>
                                    {{
                                    order_data.customer_name
                                    ? order_data.customer_name
                                    : ""
                                    }}
                                  </td>
                                </tr>
                              
                                
                                <tr v-if="customer_email !=null">
                                  <td class="w-35 bg-gray-light">Customer email</td>
                                  <td class="w-65">{{ customer_email }}</td>
                                </tr>

                                <tr v-if="customerAddresses.length && $can('update-merchant-from-techpack')">
                                  <td class="w-35 bg-gray-light">Customer Address</td>

                                  <td class="w-65">
                               
                                 <v-select
                                    v-model="customer_address"
                                    :options="customerAddresses"
                                    :get-option-label="c => c.address1 || 'No Address'"
                                    :clearable="false"
                                    placeholder="Select Customer Address"
                                    @input="handleAddressChange"
                                    v-validate="{ required: true }"
                                  />
                                  </td>
                                  
                                </tr>

                              
                                <tr>
                                  <td class="w-35 bg-gray-light">
                                    Order comments
                                  </td>
                                  <td class="w-65">
                                    <textarea
                                      v-model="order_data.general_comments"
                                      class="form-control"
                                      style="max-height: 364px"
                                    ></textarea>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td
                            class="w-50 v-align-top"
                            style="padding-left: 5pt"
                          >
                            <table class="table-fixed table-border w-100">
                              <tbody>
                                <tr>
                                  <td class="w-35 bg-gray-light">First name</td>
                                  <td class="w-65">
                                    <template v-if="order_data.shipping_address">
                                      <input
                                        type="text"
                                        class="form-control"
                                        :name="`first_name`"
                                        data-vv-as="first name"
                                        v-model="
                                          order_data.shipping_address.first_name
                                        "
                                        v-validate="{ required: true }"
                                      />
                                      <div v-if="errors" class="p-1 error_msg">
                                        {{ errors.first(`first_name`) }}
                                      </div>
                                    </template>
                                    <template v-else>
                                      N/A
                                    </template>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="w-35 bg-gray-light">Last name</td>
                                  <td class="w-65">
                                    <template v-if="order_data.shipping_address">
                                      <input
                                        type="text"
                                        class="form-control"
                                        :name="`last_name`"
                                        data-vv-as="last name"
                                        v-model="
                                          order_data.shipping_address.last_name
                                        " v-validate="{ required: true }" />
                                      <div v-if="errors" class="p-1 error_msg">
                                        {{ errors.first(`last_name`) }}
                                      </div>
                                    </template>
                                    <template v-else>
                                      N/A
                                    </template>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="w-35 bg-gray-light">Email</td>
                                  <td class="w-65">
                                    <template v-if="order_data.shipping_address">  
                                    <input type="text" class="form-control" v-model="
                                        order_data.shipping_address.email
                                      " />
                                    </template>
                                    <template v-else>
                                      N/A
                                    </template>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="w-35 bg-gray-light">Phone</td>
                                  <td class="w-65">
                                    <template v-if="order_data.shipping_address">
                                      <input type="text" class="form-control" :name="`phone_no`" data-vv-as="phone number"
                                        v-model="
                                          order_data.shipping_address.phone_number
                                        " v-validate="{ required: true }" />
                                      <div v-if="errors" class="p-1 error_msg">
                                        {{ errors.first(`phone_no`) }}
                                      </div>
                                    </template>
                                    <template v-else>
                                      N/A
                                    </template>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="w-35 bg-gray-light">Company</td>
                                  <td class="w-65">
                                    <template v-if="order_data.shipping_address">
                                    <input type="text" class="form-control" v-model="
                                        order_data.shipping_address.company
                                      " />
                                    </template>
                                    <template v-else>
                                      N/A
                                    </template>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="w-35 bg-gray-light">
                                    Shipping address
                                  </td>
                                  <td class="w-65">
                                    <div v-if="order_data.shipping_address">
                                      <strong>Address: </strong>
                                      <div>
                                        <div class="d-flex align-items-center gap-1">
                                          <span style="
                                              white-space: nowrap;
                                              width: 110px;
                                              text-indent: 7px;
                                            ">Address 1:</span>
                                          <input type="text" class="form-control" :name="`shipping_address1`"
                                            data-vv-as="shipping address 1" v-validate="{ required: true }" v-model="
                                              order_data.shipping_address
                                                .address1
                                            " />
                                        </div>
                                        <div class="d-flex align-items-center gap-1" v-if="
                                            errors.first(`shipping_address1`)
                                          ">
                                          <span style="
                                              white-space: nowrap;
                                              width: 110px;
                                              text-indent: 7px;
                                              visibility: hidden;
                                            ">Address 1:</span>
                                          <div class="error_msg">
                                            {{
                                            errors.first(`shipping_address1`)
                                            }}
                                          </div>
                                        </div>

                                        <div class="d-flex align-items-center gap-1 mt-1">
                                          <span style="
                                              white-space: nowrap;
                                              width: 110px;
                                              text-indent: 7px;
                                            ">Address 2:</span>
                                          <input type="text" class="form-control" v-model="
                                              order_data.shipping_address
                                                .address2
                                            " />
                                        </div>
                                      </div>
                                    </div>
                                    <div v-else>
                                      N/A
                                    </div>
                                    <div v-if="order_data.shipping_address" class="d-flex align-items-center gap-1 mt-1">
                                      <strong style="width: 82px">Country:</strong>
                                      <div style="
                                          flex-shrink: 1;
                                          width: calc(100% - 82px);
                                        ">
                                        <select class="form-control" v-model="
                                            order_data.shipping_address.country
                                          ">
                                         <option 
                                            v-for="country in countries" 
                                            :key="country" 
                                            :value="country"
                                            :selected="
                                              order_data.shipping_address &&
                                              order_data.shipping_address.country &&
                                              typeof order_data.shipping_address.country === 'string' &&
                                              country &&
                                              country.toLowerCase().trim() === order_data.shipping_address.country.toLowerCase().trim()
                                            "
                                          >
                                            {{ country }}
                                          </option>
                                        </select>

                                    
                                      </div>
                                    </div>
                                    <div v-if="order_data.shipping_address" class="d-flex align-items-center gap-1 mt-1">
                                      <strong style="width: 82px">State/Province:
                                      </strong>
                                      <div style="
                                          flex-shrink: 1;
                                          width: calc(100% - 82px);
                                        ">
                                        <input type="text" class="form-control" v-model="
                                            order_data.shipping_address.state
                                          " :name="`state`" />
                                        <div v-if="errors" class="p-1 error_msg">
                                          {{ errors.first(`state`) }}
                                        </div>
                                      </div>
                                    </div>
                                    <div v-if="order_data.shipping_address" class="d-flex align-items-center gap-1 mt-1">
                                      <strong style="width: 82px">City:
                                      </strong>
                                      <div style="
                                          flex-shrink: 1;
                                          width: calc(100% - 82px);
                                        ">
                                        <input type="text" class="form-control" v-model="
                                            order_data.shipping_address.city
                                          " :name="`city`" data-vv-as="city" v-validate="{ required: true }" />
                                        <div v-if="errors" class="p-1 error_msg">
                                          {{ errors.first(`city`) }}
                                        </div>
                                      </div>
                                    </div>
                                    <div v-if="order_data.shipping_address" class="d-flex align-items-center gap-1 mt-1">
                                      <strong style="width: 82px">Zip code:
                                      </strong>
                                      <div style="
                                          flex-shrink: 1;
                                          width: calc(100% - 82px);
                                        ">
                                        <input type="text" class="form-control" v-model="
                                            order_data.shipping_address.zip_code
                                          " :name="`zip_code`" data-vv-as="zip code" v-validate="{ required: true }" />
                                        <div v-if="errors" class="p-1 error_msg">
                                          {{ errors.first(`zip_code`) }}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="w-35 bg-gray-light">
                                    Shipping Method
                                  </td>
                                  <td class="w-65">
                                    <template v-if="order_data.shipping_address">
                                      <input type="text" class="form-control" v-model="
                                        order_data.additional_fields.shipping[0]
                                          .method
                                      " />
                                    </template>
                                    <template v-else>
                                      N/A
                                    </template>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <template  v-if="factory_product.is_deleted === false">
              <table class="page fixed-table w-100-no-padding">
                <tr>
                  <template v-if="order_data.order_no">
                    <th width="15%">Order# {{ order_data.order_no }}</th>
                  </template>
                  <template v-else>
                    <th width="15%">Order pending confirmation</th>
                  </template>
                  <th width="25%">
                    SKU# {{ factory_product.sku_number }} | SKU Name:
                    {{ factory_product.sku_name }}
                  </th>
                  <th>
                    <div class="d-flex align-items-center gap-1">
                      <span style="
                          white-space: nowrap;
                          width: 110px;
                          text-indent: 7px;
                        ">Product:</span>
                        <template v-if="factory_product.is_custom_product && !is_custom_design">
                          <input type="text" class="form-control" :name="`product_name`" data-vv-as="product name" disabled  v-model="factory_product.new_product_name" />
                        </template>
                        <template v-else>
                          <input type="text" class="form-control" :name="`product_name`" data-vv-as="product name" disabled  v-model="factory_product.product_name" />
                        </template>
                    </div>
                  </th>
                  <th width="15%" class="text-right"></th>
                </tr>
                <tr>
                  <td colspan="4">
                    <table class="fixed-table order-details w-100">
                      <tbody>
                        <tr>
                          <td class="w-50" style="padding-right: 5pt">
                            <table class="fixed-table order-details w-100">
                              <tbody>
                                <tr>
                                  <td class="w-50">
                                    <template v-if="factory_product.front_image_info">
                                      <template v-if="
                                          factory_product.front_image_info
                                            .updating
                                        ">
                                        <div class="loader-wrapper absolute">
                                          <div class="loader"></div>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <div class="position-relative w-100" :style="{
                                            'min-height':
                                              factory_product.front_image_info
                                                ? '200px'
                                                : 'auto',
                                          }">
                                          <img style="
                                              max-width: 100%;
                                              height: auto;
                                            " :src="`${factory_product.front_image_info.base64String}`" />
                                        </div>
                                      </template>
                                    </template>
                                    <template v-else>
                                      <div class="position-relative w-100" :style="{
                                          'min-height':
                                            factory_product.front_image_info
                                              ? '200px'
                                              : 'auto',
                                        }">
                                        <img v-if="factory_product.front_image" style="flex-shrink: 1; width: 100%"
                                          :src="`${storageUrl}/${factory_product.front_image}`" />
                                        <img v-else style="flex-shrink: 1; width: 100%"
                                          :src="`${storageUrl}/${factory_product.custom_product_placeholder}`" />

                                      </div>
                                    </template>
                                    <div style="
                                        padding-top: 5px;
                                        margin-top: 5px;
                                        border-top: 1px solid #cccccc;
                                      ">
                                      <FileInputBox
                                        :label="`Front image - ${factory_product.product_name || ''}`"
                                        :fieldKey="`factory-product-${factory_product.id}-front-uploader`"
                                        :accept="'.png,.jpg,.jpeg,.svg'"
                                        @focus-field="onFileInputClick"
                                        @blur-field="onFileInputBlur"
                                        @input="(file) => handleFrontBackUpload('front', { target: { files: [file] } }, factory_product)"
                                      />
                                      <button v-if="factory_product.front_image_info" class="btn btn-info" @click="
                                          cancelFrontBackUpload(
                                            'front',
                                            factory_product
                                          )
                                        ">
                                        Cancel Upload
                                      </button>
                                    </div>
                                  </td>
                                  <td class="w-50">
                                    <template v-if="factory_product.back_image_info">
                                      <template v-if="
                                          factory_product.back_image_info
                                            .updating
                                        ">
                                        <div class="loader-wrapper absolute">
                                          <div class="loader"></div>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <div class="position-relative w-100" :style="{
                                            'min-height':
                                              factory_product.back_image_info
                                                ? '200px'
                                                : 'auto',
                                          }">
                                          <img style="
                                              max-width: 100%;
                                              height: auto;
                                            " :src="`${factory_product.back_image_info.base64String}`" />
                                        </div>
                                      </template>
                                    </template>
                                    <template v-else>
                                      <div class="position-relative w-100" :style="{
                                          'min-height':
                                            factory_product.back_image_info
                                              ? '200px'
                                              : 'auto',
                                        }">
                                        <template v-if="factory_product.back_image">
                                          <img style="flex-shrink: 1; width: 100%"
                                            :src="`${storageUrl}/${factory_product.back_image}`" />
                                        </template>
                                        <img v-else style="flex-shrink: 1; width: 100%"
                                          :src="`${storageUrl}/${factory_product.custom_product_placeholder}`" />
                                      </div>
                                    </template>
                                    <div class="d-flex justify-content-between" style="
                                        padding-top: 5px;
                                        margin-top: 5px;
                                        border-top: 1px solid #cccccc;
                                      ">
                                      <FileInputBox
                                        :label="`Back image - ${factory_product.product_name || ''}`"
                                        :fieldKey="`factory-product-${factory_product.id}-back-uploader`"
                                        :accept="'.png,.jpg,.jpeg,.svg'"
                                        @focus-field="onFileInputClick"
                                        @blur-field="onFileInputBlur"
                                        @input="(file) => handleFrontBackUpload('back', { target: { files: [file] } }, factory_product)"
                                      />
                                      <button v-if="factory_product.back_image_info" class="btn btn-info" @click="
                                          cancelFrontBackUpload(
                                            'back',
                                            factory_product
                                          )
                                        ">
                                        Cancel Upload
                                      </button>
                                      <Delete v-if="factory_product.back_image" title="Remove Back Image" :size="20"
                                        fillColor="#777" style="cursor: pointer" @click="
                                          removeBackImage(factory_product)
                                        " />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td class="w-50" style="padding-left: 5pt">
                            <table class="fixed-table table-border w-100 necktape">
                              <thead>
                                <tr>
                                  <th>Neck tag, piping and carelabel</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <div>
                                      <strong>Company:</strong>
                                      {{ order_data.company_name }}
                                    </div>

                                    <div>
                                      <strong>Neck tape:</strong>
                                      <input type="text" v-model="factory_product.neck_tape" class="form-control" />
                                    </div>

                                    <div class="d-flex justify-content-between">
                                      <div>
                                        <template v-if="factory_product.neck_tape_info">
                                          <template v-if="factory_product.neck_tape_info.updating">
                                            <div class="loader-wrapper absolute">
                                              <div class="loader"></div>
                                            </div>
                                          </template>
                                          <template v-else>
                                            <div class="text-center">
                                              <img v-if="factory_product.neck_tape_info.extension === 'pdf'"
                                                style="flex-shrink: 1; height: 50pt;"
                                                :src="`${storageUrl}/placeholders/pdf.svg`" />
                                              <img v-else style="flex-shrink: 1; height: 50pt; width: 100%; object-fit: contain;"
                                                :src="`${factory_product.neck_tape_info.base64String}`" />
                                            </div>
                                          </template>
                                        </template>
                                        <template v-else>
                                          <div class="text-center">
                                            <template v-if="factory_product.neck_tape_file">
                                              <template v-if="factory_product.is_neck_tape_file_pdf">
                                                <a :href="`${storageUrl}/${factory_product.neck_tape_file}`" download target="_black" :title="factory_product.neck_tape_file">
                                                  <img style="flex-shrink: 1; height: 50pt;" :src="`${storageUrl}/placeholders/pdf.svg`" />
                                                </a>
                                              </template>
                                              <template v-else>
                                                <img style="flex-shrink: 1; height: 50pt; width: 100%; object-fit: contain;"
                                                  :src="`${storageUrl}/${factory_product.neck_tape_file}`" />
                                              </template>
                                            </template>
                                          </div>
                                        </template>
                                        <div style="padding-top: 5px; margin-top: 5px; border-top: 1px solid #cccccc;">
                                          <FileInputBox
                                            :label="`Neck tape - ${factory_product.product_name || ''}`"
                                            :fieldKey="`factory-product-${factory_product.id}-neck-tape`"
                                            :accept="'.png,.jpg,.jpeg,.svg'"
                                            @focus-field="onFileInputClick"
                                            @blur-field="onFileInputBlur"
                                            @input="(file) => handleNeckTapeUpload({ target: { files: [file] } }, factory_product)"
                                          />
                                          <button v-if="factory_product.neck_tape_info" class="btn btn-info" @click="cancelNeckTapeUpload(factory_product)">
                                            Cancel Upload
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div class="d-flex justify-content-between">
                                      <div>
                                        <div class="fw-bold" style="font-weight: bold">Neck tag:</div>
                                        <template v-if="factory_product.neck_tag_info">
                                          <template v-if="factory_product.neck_tag_info.updating">
                                            <div class="loader-wrapper absolute">
                                              <div class="loader"></div>
                                            </div>
                                          </template>
                                          <template v-else>
                                            <div class="text-center">
                                              <img v-if="factory_product.neck_tag_info.extension === 'pdf'"
                                                style="flex-shrink: 1; height: 50pt;"
                                                :src="`${storageUrl}/placeholders/pdf.svg`" />
                                            </div>
                                          </template>
                                        </template>
                                        <template v-else>
                                          <div class="text-center">
                                            <template v-if="factory_product.neck_tag_logo">
                                              <template v-if="factory_product.is_neck_tag_logo_pdf">
                                                <a :href="`${storageUrl}/${factory_product.neck_tag_logo}`" download target="_black">
                                                  <img style="flex-shrink: 1; height: 50pt; width: 100%; object-fit: contain;" :title="factory_product.neck_tag_logo" :src="`${storageUrl}/placeholders/pdf.svg`" />
                                                </a>
                                              </template>
                                              <template v-else>
                                                <img style="flex-shrink: 1; height: 50pt; width: 100%; object-fit: contain;" :src="`${storageUrl}/${factory_product.neck_tag_logo}`" />
                                              </template>
                                            </template>
                                            <template v-else>
                                              <img style="flex-shrink: 1; height: 50pt; width: 100%; object-fit: contain;"
                                                v-if="order_data.company_settings?.necktag_logo?.url"
                                                :src="`${storageUrl}/${order_data.company_settings?.necktag_logo?.url}`" />
                                            </template>
                                          </div>
                                        </template>
                                        <div style="padding-top: 5px; margin-top: 5px; border-top: 1px solid #cccccc;">
                                          <FileInputBox
                                            :label="`Neck tag logo - ${factory_product.product_name || ''}`"
                                            :fieldKey="`factory-product-${factory_product.id}-neck-tag-logo`"
                                            :accept="'.png,.jpg,.jpeg,.svg'"
                                            @focus-field="onFileInputClick"
                                            @blur-field="onFileInputBlur"
                                            @input="(file) => handleNeckTagLogoUpload({ target: { files: [file] } }, factory_product)"
                                          />
                                          <button v-if="factory_product.neck_tag_info" class="btn btn-info" @click="cancelNeckTagLogoUpload(factory_product)">
                                            Cancel Upload
                                          </button>
                                        </div>
                                      </div>
                                      <div>
                                        <div class="fw-bold" style="font-weight: bold">Carelabel:</div>
                                        <template v-if="factory_product.carelabel_info">
                                          <template v-if="factory_product.carelabel_info.updating">
                                            <div class="loader-wrapper absolute">
                                              <div class="loader"></div>
                                            </div>
                                          </template>
                                          <template v-else>
                                            <div class="text-center">
                                              <img v-if="factory_product.carelabel_info.extension === 'pdf'"
                                                style="flex-shrink: 1; height: 50pt;"
                                                :src="`${storageUrl}/placeholders/pdf.svg`" />
                                            </div>
                                          </template>
                                        </template>
                                        <template v-else>
                                          <div class="text-center">
                                            <template v-if="factory_product.carelabel_logo">
                                              <template v-if="factory_product.is_carelabel_pdf">
                                                <a :href="`${storageUrl}/${factory_product.carelabel_logo}`" download target="_black">
                                                  <img style="flex-shrink: 1; height: 50pt;" :title="factory_product.carelabel_logo" :src="`${storageUrl}/placeholders/pdf.svg`" />
                                                </a>
                                              </template>
                                              <template v-else>
                                                <img style="flex-shrink: 1; height: 50pt; width: 100%; object-fit: contain;"
                                                  :src="`${storageUrl}/${factory_product.carelabel_logo}`" />
                                              </template>
                                            </template>
                                            <template v-else>
                                              <img style="flex-shrink: 1; height: 50pt; width: 100%; object-fit: contain;"
                                                v-if="order_data.company_settings?.carelabel?.url"
                                                :src="`${storageUrl}/${order_data.company_settings?.carelabel?.url}`" />
                                            </template>
                                          </div>
                                        </template>
                                        <div style="padding-top: 5px; margin-top: 5px; border-top: 1px solid #cccccc;">
                                          <FileInputBox
                                            :label="`Carelabel - ${factory_product.product_name || ''}`"
                                            :fieldKey="`factory-product-${factory_product.id}-carelabel`"
                                            :accept="'.png,.jpg,.jpeg,.svg'"
                                            @focus-field="onFileInputClick"
                                            @blur-field="onFileInputBlur"
                                            @input="(file) => handleCarelabelUpload({ target: { files: [file] } }, factory_product)"
                                          />
                                          <button v-if="factory_product.carelabel_info" class="btn btn-info" @click="cancelCarelabelUpload(factory_product)">
                                            Cancel Upload
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div>
                                      <strong>Note:</strong>
                                      <input type="text" v-model="factory_product.neck_note" class="form-control" />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table class="fixed-table order-details w-100">
                      <tbody>
                        <tr>
                          <td>
                            <label for=""><strong>Sizechart reference</strong></label>
                            <input type="text" v-model="factory_product.sizechart_reference" class="form-control" />
                          </td>
                          <td>
                            <label for="">
                              <div style="display: flex; align-items: center; gap: 8px;">
                                <strong>Products</strong>
                                <template v-if="is_manual_order">
                                  <b-form-checkbox v-model="factory_product.is_custom_product" @change="toggleCustomProduct(orderItemIndex, factory_product_index, $event)"
                                    :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-product-checkbox`">
                                    Custom Product
                                  </b-form-checkbox>
                                </template> 
                              </div>
                            </label>
                            <template v-if="factory_product.is_custom_product && !is_custom_design">
                                <input type="text" class="form-control" :name="`new_product_name`" data-vv-as="product name"
                                  v-validate="{ required: true }"
                                  v-model="factory_product.new_product_name" 
                                />
                                <div v-if="errors" class="p-1 error_msg">
                                  {{ errors.first(`new_product_name`) }}
                                </div>
                            </template>
                            <template v-else>
                              <v-select  :close-on-select="true" v-model="factory_product.selected_product_obj"
                                @input="handleProductUpdate(orderItemIndex, factory_product_index, $event)"
                                :options="all_products" :clearable="false" label="name_by_sku"
                                :key="`order-item-${orderItemIndex}factory-product-${factory_product_index}-product-options`"
                                :ref="`order-item-${orderItemIndex}factory-product-${factory_product_index}-product-options`"
                                >
                              </v-select>
                            </template> 
                          </td>
                          <template v-if="factory_product.is_custom_product && !is_custom_design">
                            <td>
                              <label for=""><strong>Design Nickname</strong></label>
                                <input type="text" class="form-control" :name="`design_nick_name`"
                                v-model="factory_product.design_nick_name" />
                                <div v-if="errors" class="p-1 error_msg">
                                  {{ errors.first(`design_nick_name`) }}
                                </div>
                            </td>
                            <td>
                              <label for=""><strong>Design ID</strong></label>
                                <input type="text" class="form-control" :name="`design_id`"
                                v-model="factory_product.design_id" />
                            </td>
                          </template>
                          <template v-else>
                            <td>
                              <label for=""><strong>Style</strong></label>
                              <v-select v-model="factory_product.selected_style_obj"
                                @input="handleStyleUpdate(orderItemIndex, factory_product_index, $event)"
                                :options="
                                  factory_product.selected_product_obj
                                    ? factory_product.selected_product_obj
                                        .productstyles
                                    : factory_product.styles
                                " :clearable="false" label="name"
                                :key="`product-${factory_product.product_id}-style-${factory_product.style_id || 'none'}`" />
                            </td>
                            <td>
                              <label for=""><strong>Design</strong></label>
                              <v-select :value="factory_product.design_name"
                                @input="handleDesignUpdate(orderItemIndex, factory_product_index, $event)"
                                  :options="factory_product?.selected_style_obj?.productdesigns" :clearable="false"
                                  :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-design`"
                                  :ref="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-design`"
                                  track-by="id" label="design_name" :disabled="!factory_product.selected_style_obj" />
                            </td>
                          </template>
                        </tr>
                        <tr>
                          <td>
                            <label for="" v-if="
                                factory_product.addons &&
                                factory_product.addons.length > 0
                              "><strong>Addons</strong></label>
                            <template v-for="(
                                addon, activeAddonIndex
                              ) in factory_product.addons">
                              <div
                                :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-addon-${activeAddonIndex}-${addon.addon_id}`">
                                <b-form-checkbox v-model="addon.selected"
                                  :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-addon-${activeAddonIndex}-${addon.addon_id}-checkbox`">
                                  {{ addon.title }}
                                </b-form-checkbox>
                              </div>
                            </template>
                          </td>
                          <td>
                            <template v-if="!factory_product.is_custom_product && !is_custom_design">
                              <template v-for="(
                                factory_product_style, fpsIdx
                              ) in factory_product.styles">
                              <label v-if="
                                  fpsIdx == 0 &&
                                  factory_product_style.customized_addons &&
                                  factory_product_style.customized_addons
                                    .ungrouped_addons
                                "
                                :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-style-${fpsIdx}-ungrouped-addons-label`">
                                <strong>Un Grouped Addons</strong>
                              </label>
                              <template v-if="
                                  factory_product_style?.id ==
                                  factory_product.selected_style_obj?.id
                                ">
                                <template v-for="(
                                    ungrouped_addon, ungroupedAddonIndex
                                  ) in factory_product_style.customized_addons
                                    .ungrouped_addons">
                                  <div
                                    :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-style-${factory_product.selected_style_obj?.id}-${fpsIdx}-ungrouped-addon-${ungroupedAddonIndex}-${ungrouped_addon.addon_id}`">
                                    <b-form-checkbox v-model="ungrouped_addon.selected"
                                      :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-style-${fpsIdx}-ungrouped-addon-${ungroupedAddonIndex}-${ungroupedAddonIndex.addon_id}-checkbox`">
                                      {{ ungrouped_addon?.sku_id }}
                                    </b-form-checkbox>
                                  </div>
                                </template>
                              </template>
                            </template>
                            </template>
                          </td>
                          <td>
                           <template v-if="!factory_product.is_custom_product && !is_custom_design">
                            <template v-for="(
                                factory_product_style, fpsIdx
                              ) in factory_product.styles">
                              <label v-if="
                                  fpsIdx == 0 &&
                                  factory_product_style.customized_addons &&
                                  factory_product_style.customized_addons
                                    .grouped_addons
                                "
                                :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-style-${fpsIdx}-ungrouped-addons-label`">
                                <strong>Grouped Addons</strong>
                              </label>
                              <template v-if="
                                  factory_product_style?.id ==
                                  factory_product.selected_style_obj?.id
                                ">
                                <template v-for="group_name in Object.keys(
                                    factory_product_style.customized_addons
                                      .grouped_addons
                                  )">
                                  <div
                                    :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-style-${factory_product.selected_style_obj.id}-${fpsIdx}-grouped-addons-container-${group_name}`">
                                    {{ group_name }}
                                  </div>
                                  <template v-for="(
                                      grouped_addon, gaIdx
                                    ) in factory_product_style.customized_addons
                                      .grouped_addons[group_name]">
                                    <b-form-checkbox v-model="grouped_addon.selected" @change="
                                        handleCustomizedAddonsUpdate(
                                          $event,
                                          factory_product_style,
                                          gaIdx,
                                          group_name
                                        )
                                      "
                                      :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-style-${fpsIdx}-grouped-addon-${gaIdx}-${grouped_addon.addon_id}-checkbox`">
                                      {{ grouped_addon?.sku_id }}
                                    </b-form-checkbox>
                                  </template>
                                </template>
                              </template>
                            </template>
                           </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td colspan="4">
                    <table class="fixed-table w-100">
                      <tbody>
                        <tr>
                          <td class="w-35">
                            <table class="fixed-table condensed left-gray w-100 table-border" style="font-size: 10pt">
                              <thead>
                                <tr>
                                  <th class="w-60">Colors</th>
                                  <th class="w-30">&nbsp;</th>
                                  <th class="w-10">&nbsp;</th>
                                </tr>
                              </thead>
                              <tbody>
                                <!-- This add svg button will be visible only if there is no svg groups. Like in case of custom product from manual order  -->
                                <template v-for="(svg_group, svgGroupIndex) in factory_product.svg_groups">
                                  <tr :key="`factory-product-${factory_product.id}-svg-group-id-${svgGroupIndex}`">
                                    <td>
                                      <template v-if="svg_group.is_custom">
                                        <input type="text" class="form-control"
                                          :key="`factory-product-${factory_product.id}-svg-group-id-${svgGroupIndex}-id`"
                                          v-model="svg_group.id">
                                      </template>
                                      <template v-else>
                                        {{ svg_group.id }}
                                      </template>
                                    </td>
                                    <td>
                                      <template v-if="
                                          svg_group.gradient_colors &&
                                          svg_group.gradient_colors.length
                                        ">
                                        <div class="d-flex flex-wrap align-items-start color_picker"
                                          style="gap: 3pt; width: 100%" v-for="(
                                            gradient_color, gradient_color_index
                                          ) in svg_group.gradient_colors"
                                          :key="`gradient_color_${gradient_color_index}`" @click="toggleColorPicker">
                                          <div class="color-box position-relative" :style="{
                                              'background-color':
                                                gradient_color.color,
                                            }">
                                            <div class="custom-popover select-color">
                                              <span class="close-it"><b-icon-x /></span>
                                              <b-tabs>
                                                <b-tab title="Color container">
                                                  <div>Select color:</div>
                                                  <div class="colors">
                                                    <template v-for="(product_colors, productColorIndex) in factory_product.product_colors">
                                                      <span v-for="(
                                                          color_json_item,
                                                          color_json_item_index
                                                        ) in product_colors.json_data"
                                                        :key="`product-${factory_product.product_id}-color-${productColorIndex}-${color_json_item_index}`"
                                                        :title="
                                                          color_json_item.name
                                                        " :style="{
                                                          'background-color':
                                                            color_json_item.value,
                                                        }" class="color-box rounded" :class="
                                                          svg_group.name ===
                                                          color_json_item.name
                                                            ? 'selected'
                                                            : ''
                                                        " @click="
                                                          handleSvgGroupUpdate(
                                                            factory_product,
                                                            svg_group,
                                                            color_json_item,
                                                            gradient_color_index
                                                          )
                                                        ">
                                                      </span>
                                                    </template>
                                                  </div>
                                                </b-tab>
                                                <b-tab title="Other colors" v-if="getTechpackIsCustomColorAllowed(techpack_product_color_types, factory_product.product_id) && getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) !== 'product_color'">
                                                  <div @click.stop>
                                                    <b-form class="pantone-color-field" v-on:submit.prevent>
                                                      <label for="inline-form-input-pantone-color" v-if="
                                                          getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) ===
                                                          'cmyk'
                                                        ">CMYK (x,x,x,x)</label>
                                                      <label for="inline-form-input-pantone-color" v-else-if="
                                                          getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) ===
                                                          'pantone-coated'
                                                        ">Pantone: (xxx c)</label>
                                                      <label class="mb-2" for="inline-form-input-pantone-color"
                                                        v-else>Pantone: (TCX
                                                        xx-xxxx)</label>
                                                      <b-form-input @focusin="
                                                          ($event) =>
                                                            $event.target.select()
                                                        " class="mb-2 mr-sm-2 mb-sm-0" :value="
                                                          gradient_color.pantone
                                                            ? gradient_color.pantone
                                                            : ''
                                                        " @input="
                                                          changePantoneColor(
                                                            $event,
                                                            order_data
                                                              .company_settings
                                                              .color_type,
                                                            svg_group,
                                                            factory_product,
                                                            gradient_color_index
                                                          )
                                                        " :placeholder="
                                                          place_holder(
                                                            order_data
                                                              .company_settings
                                                              .color_type
                                                          )
                                                        " :disabled="
                                                          getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) ===
                                                          'cmyk'
                                                        "></b-form-input>
                                                      <div class="pantone-message p-1 text-danger">
                                                        {{ pantoneMessage }}
                                                      </div>
                                                    </b-form>

                                                    <div>
                                                      <color-picker theme="light" :key="
                                                          gradient_color.color
                                                        " @changeColor="
                                                          changeColor(
                                                            $event,
                                                            order_data
                                                              .company_settings
                                                              .color_type,
                                                            factory_product.svg_groups,
                                                            svg_group,
                                                            factory_product,
                                                            gradient_color_index
                                                          )
                                                        " :color="
                                                          gradient_color.color
                                                        " :sucker-hide="true" />
                                                    </div>
                                                  </div>
                                                </b-tab>
                                              </b-tabs>
                                            </div>
                                          </div>

                                          <div style="font-size: 0.85em">
                                            {{
                                            gradient_color.pantone
                                            ? gradient_color.pantone
                                            : gradient_color.name
                                            }}
                                          </div>
                                        </div>
                                      </template>
                                      <div class="d-flex flex-wrap align-items-start color_picker" v-else
                                        style="gap: 3pt; width: 100%" @click="toggleColorPicker">
                                        <div class="color-box position-relative" :style="{
                                            'background-color': svg_group.color,
                                          }">
                                          <div class="custom-popover select-color">
                                            <span class="close-it"><b-icon-x /></span>
                                            <b-tabs>
                                              <b-tab
                                                v-for="(product_colors, productColorIndex) in resolvedColorTabs(factory_product, svg_group)"
                                                :key="`file-tab-${factory_product.product_id}-${productColorIndex}`"
                                                :title="product_colors.file_name"
                                              >
                                                <div>Select color:</div>
                                                <div class="colors">
                                                  <span
                                                    v-for="(color_json_item, color_json_item_index) in product_colors.json_data"
                                                    :key="`product-${factory_product.product_id}-color-${productColorIndex}-${color_json_item_index}`"
                                                    class="color-box rounded"
                                                    :title="color_json_item.name"
                                                    :style="{ backgroundColor: color_json_item.value }"
                                                    :class="svg_group.name === color_json_item.name ? 'selected' : ''"
                                                    @click="
                                                      handleSvgGroupUpdate(
                                                        factory_product,
                                                        svg_group,
                                                        color_json_item
                                                      )
                                                    "
                                                  >
                                                  </span>
                                                </div>
                                              </b-tab>   

                                              <b-tab title="Other colors" v-if="getTechpackIsCustomColorAllowed(techpack_product_color_types, factory_product.product_id) && getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) !== 'product_color'">

                                                <div @click.stop>
                                                  <b-form class="pantone-color-field" v-on:submit.prevent>
                                                    <label for="inline-form-input-pantone-color" v-if="
                                                        getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) === 'cmyk'
                                                      ">CMYK (x,x,x,x)</label>
                                                    <label for="inline-form-input-pantone-color" v-else-if="
                                                        getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id)===
                                                        'pantone-coated'
                                                      ">Pantone: (xxx c)</label>
                                                    <label class="mb-2" for="inline-form-input-pantone-color"
                                                      v-else>Pantone: (TCX
                                                      xx-xxxx)</label>
                                                    <b-form-input @focusin="
                                                        ($event) =>
                                                          $event.target.select()
                                                      " class="mb-2 mr-sm-2 mb-sm-0" :value="
                                                        svg_group.pantone
                                                          ? svg_group.pantone
                                                          : ''
                                                      " @input="
                                                        changePantoneColor(
                                                          $event,
                                                          order_data
                                                            .company_settings
                                                            .color_type,
                                                          svg_group,
                                                          factory_product
                                                        )
                                                      " :placeholder="
                                                        place_holder(
                                                          order_data
                                                            .company_settings
                                                            .color_type
                                                        )
                                                      " :disabled="
                                                      getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) === 'cmyk'
                                                      "></b-form-input>
                                                    <div class="pantone-message p-1 text-danger">
                                                      {{ pantoneMessage }}
                                                    </div>
                                                  </b-form>

                                                  <div>
                                                    <color-picker theme="light" :key="svg_group.color" @changeColor="
                                                        changeColor(
                                                          $event,
                                                          order_data
                                                            .company_settings
                                                            .color_type,
                                                          factory_product.svg_groups,
                                                          svg_group,
                                                          factory_product
                                                        )
                                                      " :color="svg_group.color" :sucker-hide="true" />
                                                  </div>
                                                </div>
                                              </b-tab>
                                            </b-tabs>
                                          </div>
                                        </div>

                                        <div style="font-size: 0.85em">
                                          {{
                                          svg_group.pantone
                                          ? svg_group.pantone
                                          : svg_group.name
                                          }}
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <template v-if="svg_group.is_custom">
                                        <b-icon-x class="text-danger h3" font-scale="2" style="cursor: pointer" @click="
                                            factory_product.svg_groups.splice(
                                              svgGroupIndex,
                                              1
                                            )
                                          " />
                                      </template>
                                    </td>
                                  </tr>
                                  <tr
                                    :key="`factory-product-${factory_product.id}-svg-group-id-${svgGroupIndex}-pattern`"
                                    v-if="
                                      factory_product.group_patterns &&
                                      factory_product.group_patterns[
                                        svg_group.id
                                      ]
                                    ">
                                    <td>
                                      &emsp; &#x21AA;
                                      {{
                                      formatPatternData(
                                      factory_product.group_patterns[
                                      svg_group.id
                                      ]
                                      )
                                      }}
                                    </td>
                                    <td>
                                      <template v-if="
                                          factory_product.gradient_colors &&
                                          factory_product.gradient_colors
                                            .length &&
                                          false
                                        ">
                                        <div class="d-flex flex-wrap align-items-start color_picker"
                                          style="gap: 3pt; width: 100%" v-for="(
                                            gradient_color, gradient_color_index
                                          ) in svg_group.gradient_colors"
                                          :key="`gradient_color_${gradient_color_index}`" @click="toggleColorPicker">
                                          <div class="color-box position-relative" :style="{
                                              'background-color':
                                                gradient_color.color,
                                            }">
                                            <div class="custom-popover select-color">
                                              <span class="close-it"><b-icon-x /></span>
                                              <b-tabs>
                                                <b-tab title="Color container">
                                                  <div>Select color:</div>
                                                  <div class="colors">
                                                    <template v-for="(product_colors, productColorIndex) in factory_product.product_colors">
                                                      <span v-for="(
                                                          color_json_item,
                                                          color_json_item_index
                                                        ) in product_colors.json_data"
                                                        :key="`product-${factory_product.product_id}-color-${productColorIndex}-${color_json_item_index}`"
                                                        :title="
                                                          color_json_item.name
                                                        " :style="{
                                                          'background-color':
                                                            color_json_item.value,
                                                        }" class="color-box rounded" :class="
                                                          svg_group.name ===
                                                          color_json_item.name
                                                            ? 'selected'
                                                            : ''
                                                        " @click="
                                                          handleSvgGroupUpdate(
                                                            factory_product,
                                                            svg_group,
                                                            color_json_item,
                                                            gradient_color_index
                                                          )
                                                        ">
                                                      </span>
                                                    </template>
                                                  </div>
                                                </b-tab>
                                                <b-tab title="Other colors" v-if="getTechpackIsCustomColorAllowed(techpack_product_color_types, factory_product.product_id) && getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) !== 'product_color'">
                                                  <div @click.stop>
                                                    <b-form class="pantone-color-field" v-on:submit.prevent>
                                                      <label for="inline-form-input-pantone-color" v-if="
                                                          getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) ===
                                                          'cmyk'
                                                        ">CMYK (x,x,x,x)</label>
                                                      <label for="inline-form-input-pantone-color" v-else-if="
                                                          getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) ===
                                                          'pantone-coated'
                                                        ">Pantone: (xxx c)</label>
                                                      <label class="mb-2" for="inline-form-input-pantone-color"
                                                        v-else>Pantone: (TCX
                                                        xx-xxxx)</label>
                                                      <b-form-input @focusin="
                                                          ($event) =>
                                                            $event.target.select()
                                                        " class="mb-2 mr-sm-2 mb-sm-0" :value="
                                                          gradient_color.pantone
                                                            ? gradient_color.pantone
                                                            : ''
                                                        " @input="
                                                          changePantoneColor(
                                                            $event,
                                                            order_data
                                                              .company_settings
                                                              .color_type,
                                                            svg_group,
                                                            factory_product,
                                                            gradient_color_index
                                                          )
                                                        " :placeholder="
                                                          place_holder(
                                                            order_data
                                                              .company_settings
                                                              .color_type
                                                          )
                                                        " :disabled="
                                                        getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) ===
                                                          'cmyk'
                                                        "></b-form-input>
                                                      <div class="pantone-message p-1 text-danger">
                                                        {{ pantoneMessage }}
                                                      </div>
                                                    </b-form>

                                                    <div>
                                                      <color-picker theme="light" :key="
                                                          gradient_color.color
                                                        " @changeColor="
                                                          changeColor(
                                                            $event,
                                                            order_data
                                                              .company_settings
                                                              .color_type,
                                                            factory_product.svg_groups,
                                                            svg_group,
                                                            factory_product,
                                                            gradient_color_index
                                                          )
                                                        " :color="
                                                          gradient_color.color
                                                        " :sucker-hide="true" />
                                                    </div>
                                                  </div>
                                                </b-tab>
                                              </b-tabs>
                                            </div>
                                          </div>

                                          <div style="font-size: 0.85em">
                                            {{
                                            factory_product.group_patterns[
                                            svg_group.id
                                            ].color.value
                                            ? factory_product
                                            .group_patterns[
                                            svg_group.id
                                            ].color.value
                                            : factory_product
                                            .group_patterns[
                                            svg_group.id
                                            ].color.name
                                            }}
                                          </div>
                                        </div>
                                      </template>
                                      <div class="d-flex flex-wrap align-items-start color_picker" v-else
                                        style="gap: 3pt; width: 100%" @click="toggleColorPicker">
                                        <div class="color-box position-relative" :style="{
                                            'background-color':
                                              factory_product.group_patterns[
                                                svg_group.id
                                              ].color.value,
                                          }">
                                          <div class="custom-popover select-color">
                                            <span class="close-it"><b-icon-x /></span>
                                            <b-tabs>
                                              <b-tab title="Color container">
                                                <div>Select color:</div>
                                                <div class="colors">
                                                  <template v-for="(product_colors, productColorIndex) in factory_product.product_colors">
                                                    <span v-for="(
                                                        color_json_item,
                                                        color_json_item_index
                                                      ) in product_colors.json_data"
                                                      :key="`product-${factory_product.product_id}-color-${productColorIndex}-${color_json_item_index}`"
                                                      :title="
                                                        color_json_item.name
                                                      " :style="{
                                                        'background-color':
                                                          color_json_item.value,
                                                      }" class="color-box rounded" :class="
                                                        factory_product
                                                          .group_patterns[
                                                          svg_group.id
                                                        ].color.name ===
                                                        color_json_item.name
                                                          ? 'selected'
                                                          : ''
                                                      " @click="
                                                        handlePatternUpdate(
                                                          factory_product.group_patterns,
                                                          svg_group.id,
                                                          color_json_item
                                                        )
                                                      ">
                                                    </span>
                                                  </template>
                                                </div>
                                              </b-tab>
                                              <b-tab title="Other colors" v-if="getTechpackIsCustomColorAllowed(techpack_product_color_types, factory_product.product_id) && getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) !== 'product_color'">
                                                <div @click.stop>
                                                  <b-form class="pantone-color-field" v-on:submit.prevent>
                                                    <label for="inline-form-input-pantone-color" v-if="
                                                        getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) === 'cmyk'
                                                      ">CMYK (x,x,x,x)</label>
                                                    <label for="inline-form-input-pantone-color" v-else-if="
                                                       getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) ===
                                                        'pantone-coated'
                                                      ">Pantone: (xxx c)</label>
                                                    <label class="mb-2" for="inline-form-input-pantone-color"
                                                      v-else>Pantone: (TCX
                                                      xx-xxxx)</label>
                                                    <b-form-input @focusin="
                                                        ($event) =>
                                                          $event.target.select()
                                                      " class="mb-2 mr-sm-2 mb-sm-0" :value="
                                                        svg_group.pantone
                                                          ? svg_group.pantone
                                                          : ''
                                                      " @input="
                                                        changePantoneColor(
                                                          $event,
                                                          order_data
                                                            .company_settings
                                                            .color_type,
                                                          svg_group,
                                                          factory_product
                                                        )
                                                      " :placeholder="
                                                        place_holder(
                                                          order_data
                                                            .company_settings
                                                            .color_type
                                                        )
                                                      " :disabled="
                                                      getTechpackColorType(techpack_product_color_types, svg_group.id, factory_product.product_id) === 'cmyk'
                                                      "></b-form-input>
                                                    <div class="pantone-message p-1 text-danger">
                                                      {{ pantoneMessage }}
                                                    </div>
                                                  </b-form>

                                                  <div>
                                                    <color-picker theme="light" :key="svg_group.color" @changeColor="
                                                        changeColor(
                                                          $event,
                                                          order_data
                                                            .company_settings
                                                            .color_type,
                                                          factory_product.svg_groups,
                                                          svg_group,
                                                          factory_product
                                                        )
                                                      " :color="svg_group.color" :sucker-hide="true" />
                                                  </div>
                                                </div>
                                              </b-tab>
                                            </b-tabs>
                                          </div>
                                        </div>

                                        <div style="font-size: 0.85em">
                                          {{
                                          factory_product.group_patterns[
                                          svg_group.id
                                          ].color.name
                                          ? factory_product.group_patterns[
                                          svg_group.id
                                          ].color.name
                                          : factory_product.group_patterns[
                                          svg_group.id
                                          ].color.value
                                          }}
                                        </div>
                                      </div>
                                    </td>
                                    <td class="text-center">
                                      <Delete title="Remove Logo" :size="20" fillColor="#777" style="cursor: pointer"
                                        @click="
                                          removePatternColor(
                                            factory_product.group_patterns,
                                            svg_group.id
                                          )
                                        " />
                                    </td>
                                  </tr>
                                  <!-- This add svg group button will be shown if there are svg groups in factory product. Like in case of manually added or simple product -->
                                  <tr v-if="is_manual_order && factory_product.is_custom_product && !is_custom_design && factory_product.svg_groups.length - 1 == svgGroupIndex"
                                    :key="`factory-product-${factory_product.id}-svg-group-${svgGroupIndex}-add-svg-group`">
                                    <td colspan="3">
                                      <button style="float: right;" @click="addSvgGroup(factory_product)">
                                        Add Svg Group
                                      </button>
                                    </td>
                                  </tr>
                                </template>
                              <tr
                                    :key="`factory-product-${factory_product.id}-svg-group-add-item-svg-group`">
                                  <td colspan="3">
                                    <button style="float: right;" @click="addSvgGroup(factory_product)">
                                      Add Svg Group
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>                          <td class="w-65">
                            <table
                              v-if="
                                factory_product.show_name_and_numbers ||
                                factory_product.show_fixed_texts || is_manual_order
                              "
                              class="fixed-table text-details-table condensed left-gray wrap-table w-100 table-border"
                              style="font-size: 10pt"
                            >
                              <thead
                                v-if="factory_product.show_name_and_numbers || is_manual_order"
                              >
                                <tr style="border: 1pt solid #777">
                                  <th style="border: none; width: 14%">
                                    &nbsp;
                                  </th>
                                  <th style="border: none; width: 8.5%">
                                    &nbsp;
                                  </th>
                                   <th style="border: none; width: 8.5%">
                                    &nbsp;
                                  </th>
                                  <th style="border: none; width: 25%">
                                    &nbsp;
                                  </th>
                                  <th style="border: none; width: 22%">
                                    Text, Name & Numbers
                                  </th>
                                  <th style="border: none; width: 14%">
                                    &nbsp;
                                  </th>
                                  <th style="border: none; width: 9.5%">
                                    &nbsp;
                                  </th>
                                  <th style="border: none; width: 9.5%">
                                    &nbsp;
                                  </th>
                                </tr>
                                <tr>
                                  <th class="text-center">&nbsp;</th>
                                  <th class="text-center">
                                    Height ({{
                                      order_data.company_settings
                                        .measurement_unit.unit
                                    }})<br /><span style="font-weight: lighter"
                                      >Inc outl</span
                                    >
                                  </th>
                                  <th class="text-center">Width</th>
                                  <th class="text-center">Font</th>
                                  <th class="text-center">Custom Font</th>
                                  <th class="text-center">Fill</th>
                                  <th class="text-center">Outl. Color</th>
                                  <th class="text-center">
                                    Outl. Size ({{
                                      order_data.company_settings
                                        .measurement_unit.unit
                                    }})
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="is_manual_order && factory_product.product_custom_texts.length === 0">
                                  <tr>
                                    <td colspan="7">
                                      <button style="float: right;" @click="addCustomText(orderItemIndex, factory_product_index)">
                                        Add Text
                                      </button>
                                    </td>
                                  </tr>
                                </template>
                                <template
                                  v-for="(
                                    product_custom_text,
                                    product_custom_text_index
                                  ) in factory_product.product_custom_texts"
                                >
                                  <template
                                    v-if="
                                      // factory_product.show_fixed_texts &&
                                      product_custom_text_index == 2
                                    "
                                  >
                                    <tr
                                      style="border: 1pt solid #777"
                                      :key="`text-name-numbers-${product_custom_text_index}-parent-header`"
                                    >
                                      <th style="border: none; width: 14%">
                                        &nbsp;
                                      </th>
                                      <th style="border: none; width: 8.5%">
                                        &nbsp;
                                      </th>
                                      <th style="border: none; width: 8%">
                                        &nbsp;
                                      </th>
                                      <th style="border: none; width: 25%">
                                        &nbsp;
                                      </th>
                                      <th style="border: none; width: 22%">
                                        Fixed Texts
                                      </th>
                                      <th style="border: none; width: 14%">
                                        &nbsp;
                                      </th>
                                      <th style="border: none; width: 9.5%">
                                        &nbsp;
                                      </th>
                                      <th style="border: none; width: 9.5%">
                                        &nbsp;
                                      </th>
                                    </tr>
                                    <tr :key="`text-name-numbers-${product_custom_text_index}-child-header`">
                                      <th class="text-center">&nbsp;</th>
                                      <th class="text-center">
                                        Height ({{
                                        order_data.company_settings
                                        .measurement_unit.unit
                                        }})<br /><span style="font-weight: lighter">Inc outl</span>
                                      </th>
                                      <th class="text-center">
                                        Width
                                      </th>
                                      <th class="text-center">Font</th>
                                      <th class="text-center">Custom Font</th>
                                      <th class="text-center">Fill</th>
                                      <th class="text-center">Outl. Color</th>
                                      <th class="text-center">
                                        Outl. Size ({{
                                        order_data.company_settings
                                        .measurement_unit.unit
                                        }})
                                      </th>
                                    </tr>

                                  </template>
                                  <template >
                                    <template v-for="(
                                        product_custom_text_item,
                                        product_custom_text_item_index
                                      ) in product_custom_text.items">
                                      <tr
                                        :key="`text-name-numbers-${product_custom_text_index}-item-${product_custom_text_item_index}`">
                                        <td class="bg-gray-light">
                                          <template v-if="is_manual_order && product_custom_text_item_index === 0">
                                            <b-icon-x class="text-danger h3" font-scale="2" style="cursor: pointer"
                                              @click="removeCustomText(orderItemIndex, factory_product_index, product_custom_text_index)"  
                                            />
                                          </template>
                                          <br/>
                                          {{ product_custom_text_item.label }}
                                          <br/>
                                          <template v-if="product_custom_text_item_index === 0">
                                            <template v-if="is_manual_order">
                                              <input type="text" class="form-control"
                                              :key="`factory-product-${factory_product.id}-text-${product_custom_text_index}-item-${product_custom_text_item_index}`"
                                              v-model="product_custom_text.value">
                                            </template>
                                            <template v-else>
                                              <strong v-if="product_custom_text.value">({{ product_custom_text.value }})</strong>
                                            </template>
                                          </template>
                                        </td>
                                        <td>
                                          <div class="d-flex align-items-center" style="gap: 3px">
                                            <input min="0.1" step="0.01" type="number" :value="
                                                product_custom_text_item.originalHeight
                                              " @change="
                                                handleDimensionsUpdate(
                                                  $event,
                                                  product_custom_text_item,
                                                  factory_product.measurement_ratio,
                                                  'height'
                                                )
                                              " class="form-control p-1" />
                                          </div>
                                        </td>
                                         <td>
                                          <div class="d-flex align-items-center" style="gap: 3px">
                                            <input min="0.1" step="0.01" type="number" :value="
                                                product_custom_text_item.originalWidth
                                              " @change="
                                                handleDimensionsUpdate(
                                                  $event,
                                                  product_custom_text_item,
                                                  factory_product.measurement_ratio,
                                                  'width'
                                                )
                                              " class="form-control p-1" />
                                          </div>
                                        </td>

                                        <td style="
                                            font-size: 0.85em;
                                            text-transform: capitalize;
                                          ">
                                          <select name="" id="" class="form-control" v-model="
                                              product_custom_text.font_family
                                            " v-if="
                                              factory_product.product_fonts.length > 0 && product_custom_text_item_index === 0 && !factory_product.is_custom_product && !product_custom_text.font_family_custom
                                            " :style="{
                                              'font-family':
                                                product_custom_text.font_family,
                                            }">
                                            <template v-for="font_file in factory_product.product_fonts">
                                              <option v-for="(
                                                  product_font,
                                                  product_font_index
                                                ) in font_file.json_data" :selected="
                                                  product_custom_text.font_family ===
                                                  product_font.name
                                                " :key="`size_${product_font_index}`" :value="product_font.name"
                                                :style="{
                                                  'font-family':
                                                    product_font.name,
                                                }">
                                                {{
                                                product_font.name.toUpperCase()
                                                }}
                                              </option>
                                            </template>
                                          </select>
                                        </td>
                                        <td>
                                          <input v-if="
                                              product_custom_text_item_index ===
                                              0
                                            " type="text" v-model="
                                              product_custom_text.font_family_custom
                                            " class="form-control" />
                                        </td>
                                        <td>
                                          <div class="d-flex align-items-center flex-wrap color_picker"
                                            @click="toggleColorPicker" v-if="
                                              !(
                                                factory_product
                                                  .product_custom_texts.length >
                                                  2 &&
                                                product_custom_text_index == 2
                                              )
                                            " style="gap: 3pt">
                                            <div class="color-box position-relative" :style="{
                                                'background-color':
                                                  product_custom_text_item.color,
                                              }">
                                              <div class="custom-popover select-color">
                                                <span class="close-it"><b-icon-x /></span>
                                                <b-tabs>
                                                  <b-tab title="Color container">
                                                    <div>Select color:</div>
                                                    <div class="colors">
                                                      <template v-for="(colors, productColorIndex) in factory_product.product_colors">
                                                        <span v-for="(
                                                            color_json_item,
                                                            color_json_item_index
                                                          ) in colors.json_data" :title="
                                                            color_json_item.name
                                                          " :style="{
                                                            'background-color':
                                                              color_json_item.value,
                                                          }" class="color-box rounded"
                                                          :key="`product-${factory_product.product_id}-color-${productColorIndex}-${color_json_item_index}-for-text`"
                                                          :class="
                                                            product_custom_text_item.color_pantone ===
                                                            color_json_item.name
                                                              ? 'selected'
                                                              : ''
                                                          " @click="
                                                            () => {
                                                              product_custom_text_item.color_pantone =
                                                                color_json_item.name;
                                                              product_custom_text_item.color =
                                                                color_json_item.value;
                                                            }
                                                          ">
                                                        </span>
                                                      </template>
                                                    </div>
                                                  </b-tab>
                                                  <b-tab title="Other colors" v-if="getTechpackIsCustomColorAllowed(techpack_product_color_types, factory_product.product_id)">
                                                    <div @click.stop>
                                                      <b-form class="pantone-color-field" v-on:submit.prevent>
                                                        <label for="inline-form-input-pantone-color" v-if="
                                                            order_data.company_settings.color_type ===
                                                            'cmyk'
                                                          ">CMYK (x,x,x,x)</label>
                                                        <label for="inline-form-input-pantone-color" v-else-if="
                                                            order_data.company_settings.color_type ===
                                                            'pantone-coated'
                                                          ">Pantone: (xxx
                                                          c)</label>
                                                        <label class="mb-2" for="inline-form-input-pantone-color"
                                                          v-else>Pantone: (TCX
                                                          xx-xxxx)</label>
                                                        <b-form-input @focusin="
                                                            ($event) =>
                                                              $event.target.select()
                                                          " class="mb-2 mr-sm-2 mb-sm-0" :value="
                                                            product_custom_text_item.color_pantone
                                                              ? product_custom_text_item.color_pantone
                                                              : ''
                                                          " @input="
                                                            changeTextPantoneColor(
                                                              $event,
                                                              order_data
                                                                .company_settings
                                                                .color_type,
                                                              product_custom_text_item,
                                                              'fill'
                                                            )
                                                          " :placeholder="
                                                            place_holder(
                                                              order_data
                                                                .company_settings
                                                                .color_type
                                                            )
                                                          " :disabled="
                                                          order_data.company_settings.color_type ===
                                                            'cmyk'
                                                          "></b-form-input>
                                                        <div class="pantone-message p-1 text-danger">
                                                          {{ pantoneMessage }}
                                                        </div>
                                                      </b-form>

                                                      <div>
                                                        <color-picker theme="light"
                                                          :key="`fill_${product_custom_text_item.color}`" @changeColor="
                                                            changeTextColor(
                                                              $event,
                                                              factory_product.svg_groups,
                                                              order_data
                                                                .company_settings
                                                                .color_type,
                                                              product_custom_text_item,
                                                              'fill'
                                                            )
                                                          " :color="
                                                            product_custom_text_item.color
                                                          " :sucker-hide="true" />
                                                      </div>
                                                    </div>
                                                  </b-tab>
                                                </b-tabs>
                                              </div>
                                            </div>
                                            <div style="
                                                font-size: 0.85em;
                                                margin-top: 0.2em;
                                              ">
                                              {{
                                              product_custom_text_item.color_pantone
                                              }}
                                            </div>
                                          </div>
                                          <div class="d-flex align-items-center flex-wrap color_picker" v-else
                                            style="gap: 3pt" @click="toggleColorPicker">
                                            <div class="color-box position-relative" :style="{
                                                'background-color':
                                                  product_custom_text_item.color,
                                              }">
                                              <div class="custom-popover select-color">
                                                <span class="close-it"><b-icon-x /></span>
                                                <b-tabs>
                                                  <b-tab title="Color container">
                                                    <div>Select color:</div>
                                                    <div class="colors">
                                                      <template v-for="(colors, productColorIndex) in factory_product.product_colors">
                                                        <span v-for="(
                                                            color_json_item,
                                                            color_json_item_index
                                                          ) in colors.json_data" :title="
                                                            color_json_item.name
                                                          " :style="{
                                                            'background-color':
                                                              color_json_item.value,
                                                          }" class="color-box rounded"
                                                          :key="`product-${factory_product.product_id}-color-${productColorIndex}-${color_json_item_index}-for-text`"
                                                          :class="
                                                            product_custom_text_item.color_pantone ===
                                                            color_json_item.name
                                                              ? 'selected'
                                                              : ''
                                                          " @click="
                                                            () => {
                                                              product_custom_text_item.color_pantone =
                                                                color_json_item.name;
                                                              product_custom_text_item.color =
                                                                color_json_item.value;
                                                            }
                                                          ">
                                                        </span>
                                                      </template>
                                                    </div>
                                                  </b-tab>
                                                  <b-tab title="Other colors" v-if="getTechpackIsCustomColorAllowed(techpack_product_color_types, factory_product.product_id)">
                                                    <div @click.stop>
                                                      <b-form class="pantone-color-field" v-on:submit.prevent>
                                                        <label for="inline-form-input-pantone-color" v-if="
                                                            order_data.company_settings.color_type ===
                                                            'cmyk'
                                                          ">CMYK (x,x,x,x)</label>
                                                        <label for="inline-form-input-pantone-color" v-else-if="
                                                            order_data.company_settings.color_type ===
                                                            'pantone-coated'
                                                          ">Pantone: (xxx
                                                          c)</label>
                                                        <label class="mb-2" for="inline-form-input-pantone-color"
                                                          v-else>Pantone: (TCX
                                                          xx-xxxx)</label>
                                                        <b-form-input @focusin="
                                                            ($event) =>
                                                              $event.target.select()
                                                          " class="mb-2 mr-sm-2 mb-sm-0" :value="
                                                            product_custom_text_item.color_pantone
                                                              ? product_custom_text_item.color_pantone
                                                              : ''
                                                          " @input="
                                                            changeTextPantoneColor(
                                                              $event,
                                                              order_data
                                                                .company_settings
                                                                .color_type,
                                                              product_custom_text_item,
                                                              'fill'
                                                            )
                                                          " :placeholder="
                                                            place_holder(
                                                              order_data
                                                                .company_settings
                                                                .color_type
                                                            )
                                                          " :disabled="
                                                          order_data.company_settings.color_type ===
                                                            'cmyk'
                                                          "></b-form-input>
                                                        <div class="pantone-message p-1 text-danger">
                                                          {{ pantoneMessage }}
                                                        </div>
                                                      </b-form>

                                                      <div>
                                                        <color-picker theme="light"
                                                          :key="`fill_fixed_${product_custom_text_item.color}`"
                                                          @changeColor="
                                                            changeTextColor(
                                                              $event,
                                                              factory_product.svg_groups,
                                                              order_data
                                                                .company_settings
                                                                .color_type,
                                                              product_custom_text_item,
                                                              'fill'
                                                            )
                                                          " :color="
                                                            product_custom_text_item.color
                                                          " :sucker-hide="true" />
                                                      </div>
                                                    </div>
                                                  </b-tab>
                                                </b-tabs>
                                              </div>
                                            </div>
                                            <div style="
                                                font-size: 0.85em;
                                                margin-top: 0.2em;
                                              ">
                                              {{
                                              product_custom_text_item.color_pantone
                                              }}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div class="d-flex align-items-center flex-wrap color_picker" style="gap: 3pt"
                                            @click="toggleColorPicker">
                                            <div class="color-box position-relative" :style="{
                                                'background-color':
                                                  product_custom_text_item.outline_color,
                                              }">
                                              <div class="custom-popover select-color">
                                                <span class="close-it"><b-icon-x /></span>
                                                <b-tabs>
                                                  <b-tab title="Color container">
                                                    <div>Select color:</div>
                                                    <div class="colors">
                                                      <template v-for="(colors, productColorIndex) in factory_product.product_colors">
                                                        <span v-for="(
                                                            color_json_item,
                                                            color_json_item_index
                                                          ) in colors.json_data" :title="
                                                            color_json_item.name
                                                          " :style="{
                                                            'background-color':
                                                              color_json_item.value,
                                                          }" class="color-box rounded"
                                                          :key="`product-${factory_product.product_id}-color-${productColorIndex}-${color_json_item_index}-for-text`"
                                                          :class="
                                                            product_custom_text_item.outline_color_pantone ===
                                                            color_json_item.name
                                                              ? 'selected'
                                                              : ''
                                                          " @click="
                                                            () => {
                                                              product_custom_text_item.outline_color_pantone =
                                                                color_json_item.name;
                                                              product_custom_text_item.outline_color =
                                                                color_json_item.value;
                                                            }
                                                          ">
                                                        </span>
                                                      </template>
                                                    </div>
                                                  </b-tab>
                                                  <b-tab title="Other colors" v-if="getTechpackIsCustomColorAllowed(techpack_product_color_types, factory_product.product_id)">
                                                    <div @click.stop>
                                                      <b-form class="pantone-color-field" v-on:submit.prevent>
                                                        <label for="inline-form-input-pantone-color" v-if="
                                                            order_data.company_settings.color_type ===
                                                            'cmyk'
                                                          ">CMYK (x,x,x,x)</label>
                                                        <label for="inline-form-input-pantone-color" v-else-if="
                                                            order_data.company_settings.color_type ===
                                                            'pantone-coated'
                                                          ">Pantone: (xxx
                                                          c)</label>
                                                        <label class="mb-2" for="inline-form-input-pantone-color"
                                                          v-else>Pantone: (TCX
                                                          xx-xxxx)</label>
                                                        <b-form-input @focusin="
                                                            ($event) =>
                                                              $event.target.select()
                                                          " class="mb-2 mr-sm-2 mb-sm-0" :value="
                                                            product_custom_text_item.outline_color_pantone
                                                              ? product_custom_text_item.outline_color_pantone
                                                              : ''
                                                          " @input="
                                                            changeTextPantoneColor(
                                                              $event,
                                                              order_data
                                                                .company_settings
                                                                .color_type,
                                                              product_custom_text_item,
                                                              'outline'
                                                            )
                                                          " :placeholder="
                                                            place_holder(
                                                              order_data
                                                                .company_settings
                                                                .color_type
                                                            )
                                                          " :disabled="
                                                          order_data.company_settings.color_type ===
                                                            'cmyk'
                                                          "></b-form-input>
                                                        <div class="pantone-message p-1 text-danger">
                                                          {{ pantoneMessage }}
                                                        </div>
                                                      </b-form>

                                                      <div>
                                                        <color-picker theme="light"
                                                          :key="`fill_${product_custom_text_item.outline_color}`"
                                                          @changeColor="
                                                            changeTextColor(
                                                              $event,
                                                              factory_product.svg_groups,
                                                              order_data
                                                                .company_settings
                                                                .color_type,
                                                              product_custom_text_item,
                                                              'outline'
                                                            )
                                                          " :color="
                                                            product_custom_text_item.outline_color
                                                          " :sucker-hide="true" />
                                                      </div>
                                                    </div>
                                                  </b-tab>
                                                </b-tabs>
                                              </div>
                                            </div>
                                            <div style="
                                                font-size: 0.85em;
                                                margin-top: 0.2em;
                                              ">
                                              {{
                                              product_custom_text_item.outline_color_pantone
                                              }}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div class="d-flex align-items-center" style="gap: 3px">
                                            <input min="0" max="10" type="number" :value="
                                                product_custom_text_item.outline_width_converted
                                              " @change="
                                                handleTextOutlineWidthUpdate(
                                                  $event,
                                                  product_custom_text_item,
                                                  factory_product.measurement_ratio
                                                )
                                              " class="form-control" />
                                          </div>
                                        </td>
                                      </tr>
                                    </template>
                                  </template>
                                </template>
                                <template v-if="is_manual_order && factory_product.product_custom_texts.length > 0">
                                  <tr>
                                    <td colspan="7">
                                      <button style="float: right;" @click="addCustomText(orderItemIndex, factory_product_index)">
                                        Add Text
                                      </button>
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                    
                <tr v-if="is_manual_order">
                  <td colspan="4">
                    <table class="table-fixed assets" style="border-spacing: 4px; border-collapse: separate">
                      <tbody>
                        <tr>
                          <td>
                            <h4>Assets</h4>
                               <div style="
                                        padding-top: 5px;
                                        margin-top: 5px;
                                        border-top: 1px solid #cccccc;
                                        max-width: max-content;
                                      ">
                                      <FileInputBox
                                        :label="`Assets - ${factory_product.product_name || ''}`"
                                        :fieldKey="`factory-product-${factory_product.id}-order-${orderItemIndex}-assets-ref`"
                                        :accept="'.png, .svg, .jpg, .jpeg, .pdf, .cdr, .svg, .tif, .tiff, .zip'"
                                        :multiple="true"
                                        @focus-field="onFileInputClick"
                                        @blur-field="onFileInputBlur"
                                        @input="(files) => uploadProductAssets({ target: { files: files instanceof Array ? files : [files] } }, orderItemIndex, factory_product_index)"
                                      />
                                      </div>
                          </td>
                        </tr>
                        <tr class="d-flex flex-wrap" >
                       <template v-for="(asset_info_obj, assetInfoIndex) in factory_product.assets_info">
                            <td :key="`factory-product-${factory_product.id}-assets-${assetInfoIndex}`" style="width: 25%;">
                              <div style="width: 100%; gap: 4px; height: 100%">
                                <div style="flex-shrink: 1" class="position-relative h-100 w-100">
                                  <div class="text-center bg-gray-light" style="padding: 5pt; color: #333">
                                    <template v-if="asset_info_obj.updating">
                                      <div class="loader-wrapper absolute">
                                          <div class="loader"></div>
                                    </div>
                                    </template>
                                    <template v-else>
                                        <div class="d-flex align-items-center gap-1">
                                          <button class="btn btn-sm btn-dark mb-2" title="Remove Asset"
                                            @click="removeAsset(orderItemIndex ,factory_product_index, assetInfoIndex)" 
                                            v-if="!asset_info_obj.is_deleted"
                                          >
                                            <Delete :size="20"
                                          />
                                          </button>
                                          <button class="btn btn-sm btn-dark mb-2" v-if="asset_info_obj.is_deleted"
                                             @click="undoDelete(orderItemIndex ,factory_product_index ,assetInfoIndex)">
                                             Restore
                                          </button>
                                      </div>
                                      <div class="position-relative w-100 h-50">
                                        <template v-if="asset_info_obj.base64_file">
                                          <img :src="`${asset_info_obj.base64_file}`"
                                            :alt="asset_info_obj.name" style="width: 100%;"/>
                                        </template>
                                        <template v-else>
                                          <img :src="`${storageUrl}/${asset_info_obj.path}`"
                                            :alt="asset_info_obj.name" style="width: 100%;" :class="{
                                             'faded_image' :   asset_info_obj.is_deleted
                                            }"/>
                                        </template>
                                      </div>
                                      <div style="
                                          padding-top: 5px;
                                          margin-top: 5px;
                                          border-top: 1px solid #cccccc;
                                        ">
                                      </div>
                                    </template>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td colspan="4">
                    <table class="table-fixed logos w-100" style="border-spacing: 4px; border-collapse: separate">
                      <tbody>
                        <tr>
                          <td>
                            <h4>Logos</h4>
                               <div v-if="is_manual_order" style="
                                        padding-top: 5px;
                                        margin-top: 5px;
                                        border-top: 1px solid #cccccc;
                                        width: fit-content;
                                      ">
                                      <FileInputBox
                                        :label="`Logos - ${factory_product.product_name || ''}`"
                                        :fieldKey="`factory-product-${factory_product.id}-order-${orderItemIndex}-logos-ref`"
                                        :accept="'.png, .svg, .jpg, .jpeg, .pdf, .cdr, .svg, .tif, .tiff, .zip'"
                                        :multiple="true"
                                        @focus-field="onFileInputClick"
                                        @blur-field="onFileInputBlur"
                                        @input="(files) => UploadProductLogo({ target: { files: files instanceof Array ? files : [files] } }, orderItemIndex, factory_product_index)"
                                      />
                                </div>
                          </td>
                        </tr>
                        <tr class="custom_logo_grid" v-for="(
                            logos_chunk, logos_chunk_index
                          ) in makeArrayApart(
                            factory_product.custom_logos,
                            5,
                            true
                          )" :key="`custom-logos-${logos_chunk_index}`">
                          <template v-for="(logo, logo_index) in logos_chunk">
                            <td class="" style="page-break-inside: avoid" :key="`custom-logos-${logo_index}`">
                              <div style="gap: 4px" :class="{
                                'w-full': logo.show_loader,
                                'w-fit': !logo.show_loader
                              }">
                                <div style="flex-shrink: 1" class="">
                                  <div class="text-center bg-gray-light" style="padding: 5pt; color: #333">
                                    <div class="d-flex align-items-center gap-1">
                                      <Delete v-if="
                                          logo.updated_logo_info || logo.url
                                        " title="Remove Logo" :size="20" fillColor="#777" style="cursor: pointer"
                                        @click="DeleteLogo(logo)" />
                                      <template v-if="
                                          logo.updated_logo_info || logo.url
                                        ">
                                        <div class="d-flex align-items-center" style="gap: 4px">
                                          W:
                                          <input type="text" @change="
                                              handleDimensionsUpdate(
                                                $event,
                                                logo,
                                                factory_product.measurement_ratio,
                                                'width'
                                              )
                                            " :value="logo.originalWidth" class="form-control p-1"
                                            style="min-width: 50px" />
                                          {{
                                          order_data.company_settings
                                          .measurement_unit.unit
                                          }}
                                        </div>
                                        x
                                        <div class="d-flex align-items-center" style="gap: 4px">
                                          H:
                                          <input type="text" @change="
                                              handleDimensionsUpdate(
                                                $event,
                                                logo,
                                                factory_product.measurement_ratio,
                                                'height'
                                              )
                                            " :value="logo.originalHeight" class="form-control p-1"
                                            style="min-width: 50px" />
                                          {{
                                          order_data.company_settings
                                          .measurement_unit.unit
                                          }}
                                        </div>
                                      </template>
                                    </div>
                                    <div class="position-relative w-100" :style="{
                                        'min-height': logo.show_loader
                                          ? '200px'
                                          : 'auto',
                                      }">
                                      <template v-if="logo.show_loader">
                                        <div class="loader-wrapper absolute">
                                          <div class="loader"></div>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <img v-if="logo.updated_logo_info" style="max-width: 100%; height: auto"
                                          :src="`${storageUrl}/${logo.updated_logo_info.url}`" :alt="
                                            logo.updated_logo_info.file_name
                                          " />
                                        <img v-else-if="logo.url" :src="`${storageUrl}/${logo.url}`"
                                          :alt="logo.file_name" />
                                        <span v-else> Upload Logo </span>
                                      </template>
                                    </div>
                                    <div style="
                                        padding-top: 5px;
                                        margin-top: 5px;
                                        border-top: 1px solid #cccccc;
                                      ">
                                          <FileInputBox
                                            v-if="logo.updated_logo_info === null && logo.show_loader === false"
                                            :label="'Logo Upload'"
                                            :fieldKey="`logo-upload-${logo.id}`"
                                            :accept="'.png,.jpg,.jpeg,.svg'"
                                            @focus-field="onFileInputClick"
                                            @blur-field="onFileInputBlur"
                                            @input="(file) => handleLogoUpdate({ target: { files: [file] } }, logo)"
                                          />
                                      <button class="btn btn-info" @click="handleCancelUploadLogo(logo)" v-if="
                                          logo.updated_logo_info !== null &&
                                          logo.show_loader === false
                                        ">
                                        Cancel Upload
                                      </button>
                                    </div>
                                  </div>

                                  <div style="margin-top: 5pt" v-if="logo.show_loader === false">
                                    <template v-for="(
                                        logo_color, logo_color_index
                                      ) in logo.updated_logo_info
                                        ? logo.updated_logo_info.logo_colors
                                        : logo.logo_colors">
                                      <div :key="`logo-${logo_index}-colors-${logo_color_index}-container`" style="
                                          display: flex;
                                          align-items: center;
                                          cursor: pointer;
                                        ">
                                        <Delete title="Remove Color" :size="20" fillColor="#777" style="cursor: pointer"
                                          v-if="logo_color.hex" @click="
                                            removeLogoColor(
                                              logo,
                                              logo_color_index
                                            )
                                          " />
                                        <div v-else style="
                                            width: 20px;
                                            height: 20px;
                                            background: transparent;
                                          "></div>
                                        <div class="d-flex flex-wrap align-items-center color_picker"
                                          :key="`logo-${logo_index}-colors-${logo_color_index}`"
                                          @click="toggleColorPicker" style="gap: 3pt; width: 100%">
                                          <div class="color-box position-relative" :style="{
                                              'background-color':
                                                logo_color.hex,
                                            }">
                                            <div class="custom-popover select-color">
                                              <span class="close-it"><b-icon-x /></span>
                                              <b-tabs>
                                                <b-tab title="Color container">
                                                  <div>Select color:</div>
                                                  <div class="colors">
                                                    <template v-for="(product_colors, productColorIndex) in factory_product.product_colors">
                                                      <span v-for="(
                                                          color_json_item,
                                                          color_json_item_index
                                                        ) in product_colors.json_data"
                                                        :key="`product-${factory_product.product_id}-color-${productColorIndex}-${color_json_item_index}`"
                                                        :title="
                                                          color_json_item.name
                                                        " :style="{
                                                          'background-color':
                                                            color_json_item.value,
                                                        }" class="color-box rounded" :class="
                                                          logo_color.name ===
                                                          color_json_item.name
                                                            ? 'selected'
                                                            : ''
                                                        " @click="
                                                          handleLogoColorUpdate(
                                                            logo,
                                                            logo_color_index,
                                                            color_json_item
                                                          )
                                                        ">
                                                      </span>
                                                    </template>
                                                  </div>
                                                </b-tab>
                                                <b-tab title="Other colors" v-if="getTechpackIsCustomColorAllowed(techpack_product_color_types, factory_product.product_id)">
                                                  <div @click.stop>
                                                    <b-form class="pantone-color-field" v-on:submit.prevent>
                                                      <label for="inline-form-input-pantone-color" v-if="
                                                          order_data.company_settings.color_type ===
                                                          'cmyk'
                                                        ">CMYK (x,x,x,x)</label>
                                                      <label for="inline-form-input-pantone-color" v-else-if="
                                                          order_data.company_settings.color_type ===
                                                          'pantone-coated'
                                                        ">Pantone: (xxx c)</label>
                                                      <label class="mb-2" for="inline-form-input-pantone-color"
                                                        v-else>Pantone: (TCX
                                                        xx-xxxx)</label>
                                                      <b-form-input @focusin="
                                                          ($event) =>
                                                            $event.target.select()
                                                        " class="mb-2 mr-sm-2 mb-sm-0" :value="
                                                          logo_color.pantone
                                                            ? logo_color.pantone
                                                            : ''
                                                        " @input="
                                                          handleLogoColorPantoneUpdate(
                                                            $event,
                                                            order_data
                                                              .company_settings
                                                              .color_type,
                                                            logo,
                                                            logo_color_index
                                                          )
                                                        " :placeholder="
                                                          place_holder(
                                                            order_data
                                                              .company_settings
                                                              .color_type
                                                          )
                                                        " :disabled="
                                                        order_data.company_settings.color_type ===
                                                          'cmyk'
                                                        "></b-form-input>
                                                      <div class="pantone-message p-1 text-danger">
                                                        {{ pantoneMessage }}
                                                      </div>
                                                    </b-form>
                                                    <div>
                                                      <color-picker theme="light"
                                                        :key="`logo-${logo.id}-logo-color-${logo_color_index}-color-picker-${logo_color.hex}`"
                                                        @changeColor="
                                                          handleLogoColorPantoneUpdate(
                                                            $event,
                                                            order_data
                                                              .company_settings
                                                              .color_type,
                                                            logo,
                                                            logo_color_index
                                                          )
                                                        " :color="logo_color.hex" :sucker-hide="true" />
                                                    </div>
                                                  </div>
                                                </b-tab>
                                              </b-tabs>
                                            </div>
                                          </div>
                                          <div style="font-size: 0.85em">
                                            <template v-if="logo_color.hex">
                                              {{
                                              logo_color.pantone
                                              ? logo_color.pantone
                                              : logo_color.name
                                              }}
                                            </template>
                                            <template v-else>
                                              Select color
                                            </template>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td colspan="4" :key="`custom-logos-tech-${logo_index}`">
                              <table class="table-fixed logos w-100" style="
                                  border-spacing: 4px;
                                  border-collapse: separate;
                                ">
                                <tbody>
                                  <tr :key="`custom-logos-${logos_chunk_index}`">
                                    <td :key="`custom-logos-${logo_index}`">
                                      <label for="" v-if="
                                          factory_product.logo_technologies &&
                                          factory_product.logo_technologies
                                            .length > 0
                                        "><strong>Logo Technology</strong></label>
                                      <b-form-radio-group v-model="logo.logo_technology"
                                        :name="`logo-tech-group-${logo_index}`">
                                        <b-form-radio v-for="(
                                            logo_tech, logoTechIndex
                                          ) in factory_product.logo_technologies" :key="`logo-tech-${logoTechIndex}`"
                                          :value="logo_tech" :selected="
                                              logo_tech?.sku_id ==
                                              logo.logo_technology?.sku_id
                                          ">
                                          {{ logo_tech.label }}
                                        </b-form-radio>
                                      </b-form-radio-group>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </template>

                          <td :key="empty_logo" v-for="empty_logo in 5 - logos_chunk.length"></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </table>

              <table class="page fixed-table w-100-no-padding page-break-before"
                style="margin-top: 5pt; margin-bottom: 50pt">
                <tbody>
                  <tr>
                    <td colspan="3">
                      <table class="table-fixed w-35 compact-table table-border no-page-break-inside"
                        style="margin: 5pt auto; font-size: 10pt">
                        <thead>
                          <tr>
                            <th colspan="2" class="bg-gray-light text-center">
                              Summary
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="roster_summary_size in factory_product
                              .roster_summary.sizes">
                            <tr :key="`roster-size-${roster_summary_size.name}-summary`">
                              <td>{{ roster_summary_size.name }}</td>
                              <td>{{ roster_summary_size.quantity }}</td>
                            </tr>
                          </template>

                          <tr>
                            <td><strong>Grand Total</strong></td>
                            <td>
                              <strong>{{
                                factory_product.roster_summary.total_quantity
                                }}</strong>
                            </td>
                          </tr>
                          <tr v-if="factory_product.product_roster_detail.length === 0">
                            <td colspan="2">
                              <button style="float: right"
                                @click="addPlayer(factory_product)">
                                Add Player
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="w-100 d-flex flex-column align-items-end gap-1">
                        <button
                          class="btn btn-secondary" 
                          @click="downloadTemplate(factory_product?.product_id , factory_product?.selected_product_obj ? factory_product?.selected_product_obj.sku.sku_id: factory_product?.sku_name)"
                          v-if="!factory_product.is_custom_product"
                         >
                           Download Roster file template
                        </button>
                        <label class="btn btn-secondary" :for="`${'roster_upload'}_${factory_product?.id}`">
                          Upload Roster
                        </label>
                          <input type='file' class="d-none" accept=".xlsx" :id="`${'roster_upload'}_${factory_product?.id}`" @change="handleRosterUpload($event, orderItemIndex, factory_product_index)"/>
                      </div>
                      <div class="roster-container">
                        <div
                          class="roster-header bg-gray-light text-center"
                          :class="{
                            'half-grid': factory_product.product_roster_detail.length > 1,
                          }"
                        >
                          <!-- Left Panel Header -->
                           <div class='header-inner'>
                            <div class="cell">Name</div>
                            <div class="cell">No.</div>
                            <div class="cell">Size</div>
                            <div class="cell">Qty</div>
                            <div class="cell">Packing</div>
                            <div class="cell">QC</div>
                            <div class="cell"></div>
                          </div>

                          <!-- Right Panel Header (only if >1) -->
                          <div v-if="factory_product.product_roster_detail.length > 1" class='header-inner'>
                            <div class="cell">Name</div>
                            <div class="cell">No.</div>
                            <div class="cell">Size</div>
                            <div class="cell">Qty</div>
                            <div class="cell">Packing</div>
                            <div class="cell">QC</div>
                            <div class="cell"></div>
                          </div>
                        </div>

                        <!-- This wrapper will auto-break into 2 columns -->
                        <div class="roster-body" 
                          :class="{
                            'half-grid': factory_product.product_roster_detail.length > 1
                          }">
                          <div
                            v-for="(roster, roster_index) in factory_product.product_roster_detail"
                            :key="`roster-${roster_index}`"
                            class="roster-row"
                            >
                            <div class="cell">
                              <input
                                type="text"
                                :value="roster.text"
                                class="form-control"
                                @change="handleRosterNameAndNumberUpdate($event, roster, factory_product)"
                              />
                            </div>

                            <div class="cell">
                              <input
                                type="number"
                                min="0"
                                :value="roster.number"
                                class="form-control"
                                @change="handleRosterNameAndNumberUpdate($event, roster, factory_product)"
                              />
                            </div>

                            <div class="cell">
                              <template
                                v-if="factory_product.product_sizes &&
                                        factory_product.product_sizes.length > 0 &&
                                        !factory_product.is_custom_product"
                              >
                                <select class="form-control" @change="
                                            handleSizeUpdate(
                                              $event,
                                              roster.roster_index,
                                              factory_product
                                            )
                                          "
                                          :key="`roster-table-chunk-${roster_table_index}-item-${roster_index}-size-select`"
                                          >
                                          <option :selected="roster.size == null"  :value="null" v-if="roster.size == null" disabled>
                                              Please select Size
                                          </option>
                                          <template v-for="(
                                              product_size, size_index
                                            ) in factory_product.product_sizes">e
                                            <option :selected="roster.size == product_size.name" :key="`size_${size_index}`" :value="size_index">
                                      {{ product_size.name }}
                                    </option>
                                  </template>
                                </select>
                              </template>
                              <template v-else>
                                <input
                                  type="text"
                                  :value="roster.size"
                                  class="form-control"
                                  @input="handleSizeUpdate($event, roster.roster_index, factory_product, true)"
                                />
                              </template>
                            </div>

                            <div class="cell">
                              <input
                                type="number"
                                min="0"
                                v-model="roster.quantity"
                                class="form-control"
                                @change="handleRosterUpdate(factory_product)"
                              />
                            </div>

                            <div class="cell"></div>
                            <div class="cell"></div>
                            <div class="cell">
                              <div class="delete-icon" @click="handlePlayerDelete(factory_product, roster.roster_index)">
                                <Delete :size="20" fillColor="#777" />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="roster-footer text-right">
                          <button @click="addPlayer(factory_product)">Add Player</button>
                          <button class="ml-2" @click="copyRoster(factory_product)">Copy Roster</button>
                          <button class="ml-2" v-if="copiedRoster.isAnyRosterCopied && copiedRoster.copiedRosterFromId !== factory_product.id" @click="pasteRoster(factory_product)">Paste Roster</button>
                        </div>
                      </div>


                    </td>
                  </tr>
                </tbody>
              </table>
              <template v-if="factory_product.specs_sheet_url">
                <table class="table-fixed w-100 mb-4">
                  <tbody>
                    <tr>
                      <td class="w-50">
                        <table class="table-border roster-table condensed fixed-table w-100" style="font-size: 10pt">
                          <thead>
                            <tr>
                              <th style="width: 41%">Specs Sheet</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr :key="`specs_sheet${factory_product.id}`">
                              <td>
                                <img
                                  style="max-width: 100%; height: auto"
                                  :src="`${factory_product.specs_sheet_url}`"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </template>
          </div>
          <button 
              :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-remove-btn`" 
              v-if="factory_product.is_deleted === false && !(orderItemIndex == 0 && factory_product_index == 0)"
              class="btn btn-danger" style="text-align: right" @click="removeOrRestoreFactoryProduct(factory_product)"
            >
            Remove Product
          </button>
          <button :key="`order-item-${orderItemIndex}-factory-product-${factory_product_index}-undo-btn`"
            v-if="factory_product.is_deleted" class="btn btn-success" style="text-align: right"
            @click="removeOrRestoreFactoryProduct(factory_product, 'restore')">
            Restore Product
          </button>
        </div>
      </template>
      <template>
        <AddProductModal
          v-if="showAddProductModal"
          :customer-id="order_data.customer_id"
          :company-id="order_data.company_id"
          :order-item="getCurrentOrderItemForModal()"
          :locker-room="addProductModalData.lockerRoom"
          :factories="addProductModalData.factories"
          :company-products="addProductModalData.companyProducts"
          :copied-roster="copiedRoster"
          @product-added="handleProductAdded"
          @on-close="handleCloseAddProductModal"
          @add-factory-product="handleAddFactoryProduct"
          @copy-roster="handleCopyRoster"
        />
      </template>           
      <div class="d-flex align-items-center justify-content-end gap-1">
         <button 
        class="btn btn-success btn-lg" 
        @click="openAddProductModal"        
      >
        <i class="fa fa-plus"></i> Create Item
      </button>
        <button class="btn btn-success btn-lg" @click="resetTechPack" :disabled="updating_logos_count > 0" :title="
            updating_logos_count > 0
              ? 'Please wait logo\'s being updating'
              : 'Reset Techpack'
          ">
          Reset Techpack
        </button>
        <button class="btn btn-success btn-lg" @click="updateTechPack" :disabled="updating_logos_count > 0" :title="
            updating_logos_count > 0
              ? 'Please wait logo\'s being updating'
              : 'Update Techpack'
          ">
          Update Techpack
        </button>
        <button class="btn btn-info btn-lg" disabled="disabled" v-if="updating_logos_count > 0" :title="
            updating_logos_count > 0
              ? 'Please wait logo\'s being updating'
              : 'Cancel'
          ">
          Cancel
        </button>
        <router-link class="btn btn-info btn-lg" :to="{ name: 'Dashboard' }" title="Cancel" v-else>
          Cancel
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { http } from "@/config/httpCommon";
import {
  fileToBase64,
  getDomDocument,
  getLogoUpdatedProps,
  handleResponseException,
  logData,
  santaClone,
  showToast,
  unitConversion,
  getTechpackColorType,
  getTechpackIsCustomColorAllowed
} from "@/helpers/Helpers";
import { getClosestColor, getColorEncoding } from "@/helpers/pantoneColor.ts";
import colorPicker from "@caohenghu/vue-colorpicker";
import _, { find } from "lodash";
import readXlsxFile from 'read-excel-file';
import Delete from "vue-material-design-icons/Delete.vue";
import AddProductModal from "@/views/order/AddProductModal.vue";

export default {

  components: {
    colorPicker,
    Delete,
    FileInputBox: () => import('@/components/FileInputBox.vue'),
    AddProductModal
  },
  data() {
    return {
      countries: [
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Brazil",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Comoros",
        "Congo (Congo-Brazzaville)",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Cyprus",
        "Czechia (Czech Republic)",
        "Democratic Republic of the Congo",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini (fmr. Swaziland)",
        "Ethiopia",
        "Fiji",
        "Finland",
        "France",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Greece",
        "Grenada",
        "Guatemala",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Holy See",
        "Honduras",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Morocco",
        "Mozambique",
        "Myanmar (formerly Burma)",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "North Korea",
        "North Macedonia (formerly Macedonia)",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine State",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Qatar",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Korea",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Sweden",
        "Switzerland",
        "Syria",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States of America",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Zambia",
        "Zimbabwe",
      ],
      pantoneMessage: "",
      showLoader: true,
      order_id: this.$route.params.order_id,
      original_order_data: {},
      order_data: null,
      techpack_product_color_types: {},
      toggle_color_index: [],
      company_settings: [],
      storageUrl: process.env.VUE_APP_FILE_URL,
      general_form: {
        measurement_unit: { id: "cm", label: "Centimeters" },
        color_type: { id: "pantone-tcx", label: "Pantone TCX" },
        logo_color_type: { id: "pantone-tcx", label: "Pantone TCX" },
        piping_text: null,
        necktag_logo: { url: "", file_id: "" },
        mail_recipients: [],
        shopify_setting: {
          shopify_token: null,
          shopify_store: null,
        },
        woocommerce_setting: {
          api_username: null,
          api_password: null,
          api_store_url: null,
          admin_auth_url: null,
          custimoo_plugin_api_secret: null,
        },
        language: {},
        currency: [],
        msrp_label: {
          is_custom_msrp_label: false,
          msrp_label: "",
          msrp_label_admin: "",
        },
      },
      updating_logos_count: 0,
      available_factory_products_count: 0,
      order_factory_products_count: 0,
      all_products: [],
      is_manual_order: false,
      is_custom_design: false,
      companies: [],
      customers: [],
      customer_email:null,
      customerAddresses:[],
      customer_address:null,      
      // Add Product Modal specific data
      showAddProductModal: false,
      addProductModalData: {
        lockerRoom: [],
        factories: [],
        companyProducts: [],
      },
      copiedRoster: {
        isAnyRosterCopied: false,
        copiedRosterFromId: null,
        rosterData: [],
      },
      showPasteModal: false,
      clipboardFile: null,
      fileFields: [],
      fileFieldsByProduct: [],
      currentPasteFieldRef: null,
      roster_table_index: 0,
    };
  },
  async mounted() {
   window.addEventListener('paste', this.handleGlobalPaste);
   // Listen for clicks outside file input boxes to clear the selected field
   document.addEventListener('click', this.handleDocumentClick);
    // Collect file fields after mount
    this.collectFileFields();

    if (this.$can("update-techpack")) {
     await this.getOrderData();
     await this.getCompanies();
     await this.handleCompanyChange(this.order_data.company_id,false);

    this.order_data.original_company_id = this.order_data.company_id
    this.order_data.original_customer_id = this.order_data.customer.id
    this.customer_email = this.order_data.customer.email
      // Refresh file fields grouping after order data is loaded
      this.$nextTick(() => {
        this.collectFileFields();
      });
      // this.getCompaniesCustomers();
      // await this.getGeneralSettings();
    
    } else {
      this.$router.push({ name: "Dashboard" });
    }
  },
  methods: {
    getTechpackColorType,
    getTechpackIsCustomColorAllowed,
   // Replace your existing handleProductAdded method with this:

    // Replace your existing handleProductAdded method with this:

    async handleProductAdded(responseData) {
      this.showAddProductModal = false;
      
      if (!responseData) {
        console.error('Invalid response data from backend');
        return;
      }
      
      const {
        factory_id,
        is_new_order_item,
        added_products,
        added_products_count,
        updated_price_info,
        updated_items_count,
        order_item_id,
        factory_name,
      } = responseData;
      
      // Format products first - ensure each has a unique ID
      const formattedProducts = added_products.map((factory_product) => {
        const formatted = this.formatFactoryProduct(factory_product);
        if (!formatted.id) {
          formatted.id = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        }
        return formatted;
      });
      
      if (is_new_order_item) {
        // CREATE NEW ORDER ITEM
        const newOrderItem = {
          id: order_item_id,
          order_id: this.order_data.id,
          factory_id: factory_id,
          factory_name: factory_name || '',
          items_count: updated_items_count,
          price_info: updated_price_info,
          status: factory_id ? 'order_approve' : 'submitted_for_factory_review',
          order: {
            id: this.order_data.id,
            order_no: this.order_data.order_no,
            order_type_detail: this.order_data.order_type_detail,
            order_type_symbol: this.order_data.order_type_symbol,
            order_type_default: this.order_data.order_type_default,
            company_id: this.order_data.company_id,
            customer_id: this.order_data.customer_id,
          },
          factory_products: formattedProducts,
        };
        
        this.order_data.items.push(newOrderItem);
        
      } else {
        // ADD TO EXISTING ORDER ITEM
        const existingItemIndex = this.order_data.items.findIndex(
          (item) => item.id === order_item_id
        );
        
        if (existingItemIndex === -1) {
          console.error('Could not find existing order item');
          return;
        }
        
        const existingItem = this.order_data.items[existingItemIndex];
        
        // Push new products to existing factory_products array
        formattedProducts.forEach(product => {
          existingItem.factory_products.push(product);
        });
        
        // Update metadata
        this.$set(existingItem, 'price_info', updated_price_info);
        this.$set(existingItem, 'items_count', updated_items_count);
      }
      
      // Update counters
      this.available_factory_products_count += added_products_count;
      this.order_factory_products_count += added_products_count;
      
      // Process newly added products - calculate roster summary
      formattedProducts.forEach((factory_product) => {
        this.handleRosterUpdate(factory_product);
      });
      
      await this.$nextTick();
      
      showToast('Product added successfully', 'success');
    },

    /**
     * Format newly added product to match existing structure
     */
    formatNewlyAddedProduct(factoryProduct) {
      if (factoryProduct.product_roster_detail) {
        factoryProduct.product_roster_detail = factoryProduct.product_roster_detail.map(
          (roster, index) => ({
            ...roster,
            roster_index: index,
          })
        );
      }

      if (!factoryProduct.groupcolors || Array.isArray(factoryProduct.groupcolors)) {
        factoryProduct.groupcolors = {};
      }

      if (factoryProduct.custom_logos) {
        factoryProduct.custom_logos = factoryProduct.custom_logos.map((logo) => ({
          ...logo,
          show_loader: false,
          updated_logo_info: null,
        }));
      }

      if (this.is_manual_order) {
        if (!factoryProduct.assets_info) {
          const assets = factoryProduct.assets || [];
          factoryProduct.assets_info = assets
            .filter((asset) => asset.path)
            .map((asset) => ({
              ...this.getAssetsDefaulObject(),
              ...asset,
            }));
        }
      }

      if (factoryProduct.product_fonts) {
        this.fontsList(factoryProduct.product_fonts);
      }
      
      this.handleRosterUpdate(factoryProduct);
    },

    /**
     * Format factory product with all required properties
     */
    /**
     * Format factory product with all required properties
     */
    /**
     * Format factory product with all required properties
     */
    formatFactoryProduct(factory_product) {
      // Load fonts first if available
      if (factory_product.product_fonts && factory_product.product_fonts.length > 0) {
        this.fontsList(factory_product.product_fonts);
      }

      // Generate a unique temporary ID for new products without an ID
      if (!factory_product.id) {
        factory_product.id = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      }

      // Find the matching product from all_products to get complete data
      const selected_product = this.all_products.find(
        (product) => product.product_id === factory_product.product_id
      );

      // Find the matching style if style_id is present
      let selected_style = null;
      if (factory_product.style_id && selected_product) {
        selected_style = selected_product.productstyles?.find(
          (style) => style.id === factory_product.style_id
        );
      }

      // Use product_name from server or fall back to selected_product
      const product_name = factory_product.product_name || 
                          (selected_product ? selected_product.display_name : '');
      
      // Use style_name from server or fall back to selected_style
      const style_name = factory_product.style_name || 
                        (selected_style ? selected_style.name : '');

      // Get product sizes from server response or selected_product
      const product_sizes = factory_product.product_sizes || 
                            (selected_product?.sizes?.[0]?.json_data || []);

      // Format roster detail with proper size mapping
      let formatted_roster_detail = [];
      if (factory_product.product_roster_detail && factory_product.product_roster_detail.length > 0) {
        const sizesMap = product_sizes.map(sizeObj => sizeObj.name);
        
        formatted_roster_detail = factory_product.product_roster_detail.map((roster, rosterIndex) => {
          // Check if the roster size exists in the product sizes
          const matchedSize = sizesMap.find(
            size => size.trim().toLowerCase() === roster?.size?.trim().toLowerCase()
          );
          
          return {
            ...roster,
            roster_index: rosterIndex,
            size: matchedSize || roster.size || (sizesMap.length > 0 ? sizesMap[0] : ''),
            code: matchedSize || roster.code || (sizesMap.length > 0 ? sizesMap[0] : ''),
          };
        });
      }

      // Format addons - server should already have selected property set correctly
      // Just use the addons directly from server response
      let formatted_addons = factory_product.addons || [];

      // Format styles with customized_addons (grouped and ungrouped)
      let formatted_styles = [];
      if (factory_product.styles && factory_product.styles.length > 0) {
        formatted_styles = factory_product.styles.map(style => {
          // Clone the style to avoid mutation
          const formatted_style = { ...style };
          
          // Server should have already set customized_addons with selected property
          // No need to reprocess if it's already there
          if (formatted_style.customized_addons) {
            return formatted_style;
          }
          
          return formatted_style;
        });
      } else if (selected_product && selected_product.productstyles) {
        // Fallback: if styles not in response, use from selected_product
        formatted_styles = selected_product.productstyles.map(style => {
          const formatted_style = { ...style };
          
          // If this is the selected style, format customized addons
          if (style.id === factory_product.style_id && style.customized_addons) {
            const customized_addons = JSON.parse(JSON.stringify(style.customized_addons));
            
            // Get selected grouped addons from server response
            const grouped_addons_from_server = factory_product.grouped_addons || {};
            
            // Format grouped addons
            if (customized_addons.grouped_addons) {
              for (const group_name in customized_addons.grouped_addons) {
                customized_addons.grouped_addons[group_name] = customized_addons.grouped_addons[group_name].map(grouped_addon => {
                  // Check if this addon is selected in the server response
                  const server_selected = grouped_addons_from_server[group_name];
                  const is_selected = server_selected && server_selected.addon_id === grouped_addon.addon_id;
                  
                  return {
                    ...grouped_addon,
                    selected: is_selected
                  };
                });
              }
            }
            
            // Get selected ungrouped addons from server response
            const ungrouped_addons_from_server = factory_product.ungrouped_addons || [];
            const ungrouped_addon_ids = ungrouped_addons_from_server.map(addon => addon.addon_id);
            
            // Format ungrouped addons
            if (customized_addons.ungrouped_addons) {
              customized_addons.ungrouped_addons = customized_addons.ungrouped_addons.map(ungrouped_addon => ({
                ...ungrouped_addon,
                selected: ungrouped_addon_ids.includes(ungrouped_addon.addon_id)
              }));
            }
            
            formatted_style.customized_addons = customized_addons;
          }
          
          return formatted_style;
        });
      }

      return {
        ...factory_product,
        
        // Set product name correctly
        product_name: product_name,
        style_name: style_name,
        
        // Ensure groupcolors is an object
        groupcolors: factory_product.groupcolors && !Array.isArray(factory_product.groupcolors) 
          ? factory_product.groupcolors 
          : {},
        
        // Format custom logos
        custom_logos: (factory_product.custom_logos || []).map((logo) => ({
          ...logo,
          show_loader: false,
          updated_logo_info: null,
        })),
        
        // Set formatted roster detail with proper sizes
        product_roster_detail: formatted_roster_detail,
        
        // Initialize assets_info for manual orders
        assets_info: this.is_manual_order 
          ? (factory_product.assets || [])
              .filter((asset) => asset.path)
              .map((asset) => ({
                ...this.getAssetsDefaulObject(),
                ...asset,
              }))
          : [],
        
        // Initialize product properties from server response or selected_product
        product_colors: factory_product.product_colors || [],
        product_fonts: factory_product.product_fonts || [],
        product_sizes: product_sizes,
        
        // CRITICAL: Initialize these arrays that are needed for rendering
        product_texts: factory_product.product_texts || [],
        logos_setting: factory_product.logos_setting || [],
        styles: formatted_styles,
        addons: formatted_addons,
        
        // Initialize selection objects - NOW WITH ACTUAL REFERENCES
        selected_product_obj: selected_product || null,
        selected_style_obj: selected_style || null,
        
        // Initialize display flags
        show_name_and_numbers: factory_product.show_name_and_numbers || false,
        show_fixed_texts: factory_product.show_fixed_texts || false,
        enable_custom_fonts: factory_product.enable_custom_fonts || false,
        
        // Initialize file type flags
        is_neck_tape_file_pdf: factory_product.is_neck_tape_file_pdf || false,
        is_neck_tag_logo_pdf: factory_product.is_neck_tag_logo_pdf || false,
        is_carelabel_pdf: factory_product.is_carelabel_pdf || false,
        
        // Initialize product_custom_texts array - IMPORTANT for manual orders
        product_custom_texts: factory_product.product_custom_texts || [],
        
        // Initialize roster_summary - CRITICAL for display
        roster_summary: factory_product.roster_summary || {
          sizes: [],
          total_quantity: 0
        },
        
        // Initialize logo_technologies array
        logo_technologies: factory_product.logo_technologies || [],
      };
    },
    async openAddProductModal() {
      // Load data if not already loaded
      if (this.addProductModalData.companyProducts.length === 0) {
        await this.loadAddProductModalData();
      }

      this.showAddProductModal = true;
      this.$nextTick(() => {
        this.$bvModal.show('add-product-modal');
      });
    },

    
    async loadAddProductModalData() {
      this.showLoader = true;
      
      try {
        await Promise.all([
          this.loadLockerRoom(),
          this.loadFactories(),
          this.loadCompanyProducts(),
        ]);
      } catch (error) {
        console.error('Error loading add product modal data:', error);
        handleResponseException(error);
      } finally {
        this.showLoader = false;
      }
    },

    
    async loadLockerRoom() {
      if (!this.order_data) return;
  
      try {
        const response = await http.get(
          `customer_lockers_rosters?company_id=${this.order_data.company_id}&customer_id=${this.order_data.customer_id}/`
        );
        
        // Filter out the placeholder "Select Locker" option
        const lockerRooms = response.data.result.customer_locker_rooms || [];
        this.addProductModalData.lockerRoom = lockerRooms.filter(locker => locker.id !== null);
      } catch (error) {
        console.error('Error loading locker room:', error);
        this.addProductModalData.lockerRoom = [];
      }
    },

    /**
     * Load factories
     */
    async loadFactories() {
      try {
        const response = await http.get('/dashboard-factories');        
        this.addProductModalData.factories = response.data.data || [];        
      } catch (error) {
        console.error('Error loading factories:', error);
        this.addProductModalData.factories = [];
      }
    },

    /**
     * Load company products
     */
    async loadCompanyProducts() {
      if (!this.order_data) return;
      
      try {
        const response = await http.get(
          `/merchant_products?company_id=${this.order_data.company_id}`
        );
        this.addProductModalData.companyProducts = response.data.result.products || [];
      } catch (error) {
        console.error('Error loading company products:', error);
        this.addProductModalData.companyProducts = [];
      }
    },

    /**
     * Handle closing the Add Product Modal
     */
    handleCloseAddProductModal() {
      this.showAddProductModal = false;
    },

    /**
     * Handle adding a factory product to the order
     * @param {Object} payload - The factory product payload
     */
    handleAddFactoryProduct(payload) {
      
      const payloadFormatted = payload.order_item || payload;
      console.log('Adding factory product with payload:', payloadFormatted);
      const factoryId = payloadFormatted.factory_id;
      let matchedItem = null;      
      matchedItem = this.order_data.items.find((item) => item.factory_id === factoryId);

      if (matchedItem) {        
        matchedItem.factory_products.push(payload.factory_products[0]);
      } else {
        
        const newOrderItem = {
          ...payloadFormatted,
          id: null,
          status: factoryId ? 'order_approve' : 'submitted_for_factory_review',
          order_id: this.order_data.id,
          order: {
            id: this.order_data.id,
            order_no: this.order_data.order_no,
            order_type_detail: this.order_data.order_type_detail,
            order_type_symbol: this.order_data.order_type_symbol,
            order_type_default: this.order_data.order_type_default,
            company_id: this.order_data.company_id,
            customer_id: this.order_data.customer_id,
          },
        };
        
        this.order_data.items.push(newOrderItem);
      }

      
      this.available_factory_products_count++;
      this.order_factory_products_count++;
      
      this.formatNewlyAddedProduct(payloadFormatted.factory_products[0]);
      this.handleRosterUpdate(payloadFormatted.factory_products[0]);
      this.handleCloseAddProductModal();
            
      this.showToast('Product added successfully', 'success');
    },

    /**
     * Format newly added product to match existing structure
     * @param {Object} factoryProduct - The factory product to format
     */
    

    /**
     * Handle copying roster from one product
     * @param {Object} copiedRosterData - Object containing product_id and rosterData
     */
    handleCopyRoster(copiedRosterData) {
      if (this.copiedRoster.isAnyRosterCopied) {
        // Confirm if user wants to overwrite existing copied roster
        this.$confirm(
          'You already have a roster copied. Do you want to copy this product\'s roster instead?',
          'Overwrite existing copied roster?',
          'warning',
          { allowOutsideClick: false }
        ).then(() => {
          this.setCopiedRoster(copiedRosterData.product_id, copiedRosterData.rosterData);
          this.showToast('Roster copied successfully', 'success');
        }).catch(() => {
          // User cancelled
        });
      } else {
        this.setCopiedRoster(copiedRosterData.product_id, copiedRosterData.rosterData);
        this.showToast('Roster copied successfully', 'success');
      }
    },

    /**
     * Set the copied roster data
     * @param {Number|String} productId - The product ID
     * @param {Array} roster - The roster data
     */
    setCopiedRoster(productId, roster) {
      this.copiedRoster.isAnyRosterCopied = true;
      this.copiedRoster.copiedFromProductIndex = productId;
      this.copiedRoster.rosterData = JSON.parse(JSON.stringify(roster)); // Deep clone
    },

    /**
     * Get the current order item for the modal
     * This creates a structure compatible with the AddProductModal expectations
     */
    getCurrentOrderItemForModal() {
      if (!this.order_data || !this.order_data.items || this.order_data.items.length === 0) {
        return {
          order: {
            id: this.order_data?.id || null,
            order_no: this.order_data?.order_no || null,
            order_type_detail: this.order_data?.order_type_detail || null,
            order_type_symbol: this.order_data?.order_type_symbol || null,
            order_type_default: this.order_data?.order_type_default || null,
            company_id: this.order_data?.company_id || null,
            customer_id: this.order_data?.customer_id || null,
            company_name: this.order_data?.company_name || null,
            customer_name: this.order_data?.customer_name || null,
          },
        };
      }

      // Return the first order item's structure
      const firstItem = this.order_data.items[0];
      return {
        order: {
          id: this.order_data.id,
          order_no: this.order_data.order_no,
          order_type_detail: this.order_data.order_type_detail,
          order_type_symbol: this.order_data.order_type_symbol,
          order_type_default: this.order_data.order_type_default,
          company_id: this.order_data.company_id,
          customer_id: this.order_data.customer_id,
          company_name: this.order_data.company_name,
          customer_name: this.order_data.customer_name,
        },
      };
    },
    logData,
    handleSvgGroupUpdate(
      factory_product,
      svg_group,
      selected_color,
      gradient_index = null
    ) {
      if (gradient_index === null) {
        svg_group.name = selected_color.name;
        svg_group.color = selected_color.value;
        svg_group.pantone = null;
        if ("pantone" in selected_color) {
          svg_group.pantone = selected_color.pantone;
        }
        factory_product.groupcolors[svg_group.id] = {
          name: selected_color.name,
          color: selected_color.value,
        };
      } else {
        svg_group["gradient_colors"][gradient_index].name = selected_color.name;
        svg_group["gradient_colors"][gradient_index].color =
          selected_color.value;
        svg_group["gradient_colors"][gradient_index].pantone = null;
        if ("pantone" in selected_color) {
          svg_group["gradient_colors"][gradient_index].pantone =
            selected_color.pantone;
        }
        factory_product.groupcolors[svg_group.id] = { gradient_colors: [] };
        svg_group["gradient_colors"].forEach(
          (gradient_color_item, gradient_color_item_index) => {
            if (gradient_index === gradient_color_item_index) {
              factory_product.groupcolors[svg_group.id]["gradient_colors"].push(
                {
                  name: selected_color.name,
                  color: selected_color.value,
                }
              );
            } else {
              factory_product.groupcolors[svg_group.id]["gradient_colors"].push(
                {
                  name: gradient_color_item.name,
                  color: gradient_color_item.color,
                }
              );
            }
          }
        );
      }
    },
    handlePatternUpdate(group_patterns, group_pattern_key, selected_color) {
      let color = { name: selected_color.name, value: selected_color.value };
      this.$set(group_patterns[group_pattern_key], "color", color);
    },
    async updateTechPack() {
      let is_confirmed = true;
      // Validation: check for any empty product selection
      let hasEmptyProduct = false;
      if (this.order_data && Array.isArray(this.order_data.items)) {
        for (const orderItem of this.order_data.items) {
          for (const factory_product of orderItem.factory_products) {
            if (!factory_product.is_custom_product && !factory_product.product_id ){
              hasEmptyProduct = true;
              break;
            }
          }
          if (hasEmptyProduct) break;
        }
      }
      if (hasEmptyProduct) {
        this.showToast('Please select product', 'error');
        return;
      }
      let allRostersMissingSize = false;

      if (this.order_data && Array.isArray(this.order_data.items)) {
        for (const orderItem of this.order_data.items) {
          for (const factory_product of orderItem.factory_products) {
            const rosterDetails = factory_product.product_roster_detail;

            if (
              !Array.isArray(rosterDetails) ||
              rosterDetails.some(roster => !roster.size || String(roster.size).trim() === '')
            ) {
              allRostersMissingSize = true;
              break;
            }
          }
          if (allRostersMissingSize) break;
        }
      }

      if (allRostersMissingSize) {
        this.showToast('Please ensure all product roster items have a size selected', 'error');
        return;
      }

      if (
        this.order_factory_products_count !=
        this.available_factory_products_count
      ) {
        is_confirmed = await this.$confirm(
          `Are You Sure You Want To Remove ${
            this.order_factory_products_count -
            this.available_factory_products_count
          } product's`
        ).catch((not_confirmed) => {
          return false;
        });
      }
      if (is_confirmed) {
        this.$validator.validate().then(async (validated) => {
          if (validated) {
            let techpack_data = await this.getUpdatedTechPackData();
            this.showLoader = true;
            http
              .post("update-techpack", techpack_data)
              .then((successResponse) => {
                this.showLoader = false;
                this.original_order_data = santaClone(this.order_data);
                showToast("Techpack updated successfully", "success");
                this.$router.push({ name: "Dashboard" });
              })
              .catch((errorResponse) => {
                this.showLoader = false;
                handleResponseException(errorResponse);
              });
          } else {
            showToast("Please fill all the required fields", "info");
          }
        });
      }
    },
    async getUpdatedTechPackData() {
      let order_data = santaClone(this.order_data);
      let techpack_data = {
        order_id: this.order_data.id,
        additional_fields: this.order_data.additional_fields,
        shipping_address: this.order_data.shipping_address,
        general_comments: this.order_data.general_comments,
        order_items: {},
        customer_id:this.order_data.customer.id,
        customer_name:this.order_data.customer.first_name+' '+this.order_data.customer.last_name,
        customer_email:this.order_data.customer.email,
        company_id:this.order_data.company.id,
        company_name:this.order_data.company.company_name,
        customer_reference_no: this.order_data.customer_reference_no
      };
      //todo make sure to remove extra properties added by method formatOrderData and manually added properties from backend api
      order_data.items.map((order_item, order_item_index) => {
        order_item.factory_products.map(async (factory_product, factory_product_index) => {
          if(!('product_name' in factory_product)) {
            factory_product.product_name = '';
          }
          if(factory_product.is_custom_product && !this.is_custom_design) {
            this.resetProduct(factory_product)
          } else {
            factory_product.design_nick_name = ""
            factory_product.new_product_name = ""
          }
          if (factory_product.addons && factory_product.addons.length > 0) {
            factory_product.addons = factory_product.addons.filter(
              (factory_product_addon) => {
                return factory_product_addon.selected;
              }
            );
          }
          
          await this.setFactoryProductSelectedCustomizedAddons(factory_product);
          //delete properties that are manually added in method formatOrderData
          delete factory_product.product_texts;
          delete factory_product.logos_setting;
          delete factory_product.is_neck_tape_file_pdf;
          delete factory_product.is_neck_tag_logo_pdf;
          delete factory_product.is_carelabel_pdf;
          delete factory_product.show_name_and_numbers;
          delete factory_product.show_fixed_texts;
          delete factory_product.enable_custom_fonts;
          delete factory_product.selected_style_obj;
          delete factory_product.styles;
          factory_product.custom_logos = factory_product.custom_logos.map(
            (custom_logo) => {
              if (custom_logo.updated_logo_info) {
                custom_logo = {...custom_logo.updated_logo_info, logo_technology: custom_logo.logo_technology};
              }
              if (custom_logo.originalHeight_back) {
                delete custom_logo.originalHeight_back;
              }
              delete custom_logo.updated_logo_info;
              delete custom_logo.show_loader;
              
              return custom_logo;
            }
          );
          factory_product.product_roster_detail =
            factory_product.product_roster_detail.map(
              (product_roster_detail_item) => {
                delete product_roster_detail_item.roster_index;
                return product_roster_detail_item;
              }
            );
          delete factory_product.measurement_ratio;
          delete factory_product.roster_summary;
          delete factory_product.product_colors;
          delete factory_product.product_fonts;
          delete factory_product.product_sizes;
          factory_product.updated_sku_number = factory_product?.selected_product_obj?.sku?.sku_number ?? null;
          delete factory_product.selected_product_obj;

          // add assets info for manual order
          factory_product.assets_info = factory_product.assets || [];

          return factory_product;
        });
        techpack_data["order_items"][order_item.id] = order_item;
        return order_item;
      });
      return techpack_data;
    },
    handleLogoUpdate_back(event, logo) {
      if (event.target.files.length > 0) {
        const logo_obj = santaClone(logo);
        const file = event.target.files[0];
        const form_data = new FormData();
        form_data.append("file", file);
        form_data.append("company_id", this.order_data.company_id);
        form_data.append("customer_id", this.order_data.customer_id);
        logo.show_loader = true;
        ++this.updating_logos_count;
        http
          .post("upload-techpack-logo", form_data)
          .then((successResponse) => {
            let response_data = successResponse.data;
            if (response_data.success) {
              logo.updated_logo_info = {
                ...logo_obj,
                ...getLogoUpdatedProps(response_data.result.customer_logo),
              };
              const logo_dimensions = response_data.result.logo_dimensions;
              //this is temp value stored it will be used will logo is cancelled then need to revert it value
              logo.originalHeight_back = logo.originalHeight;
              logo.originalHeight =
                (parseFloat(logo_dimensions.height) /
                  parseFloat(logo_dimensions.width)) *
                parseFloat(logo.originalHeight);
              showToast(response_data.message);
            } else {
              showToast(response_data.message, "info");
            }
            --this.updating_logos_count;
            logo.show_loader = false;
          })
          .catch((errorResponse) => {
            logo.show_loader = false;
            --this.updating_logos_count;
            handleResponseException(errorResponse);
          });
      } else {
        logo.updated_logo_info = null;
      }
    },
    handleLogoUpdate(event, logo) {
      const file = event.target.files?.[0];
      if (file) {
        this.uploadLogo(file, logo);
      } else {
        logo.updated_logo_info = null;
      }
    },
    async uploadLogo(file, logo) {
      const logo_obj = santaClone(logo);
      const form_data = new FormData();
      form_data.append("file", file);
      form_data.append("company_id", this.order_data.company_id);
      form_data.append("customer_id", this.order_data.customer_id);

      logo.show_loader = true;
      ++this.updating_logos_count;

      try {
        const successResponse = await http.post("upload-techpack-logo", form_data);
        const response_data = successResponse.data;

        if (response_data.success) {
          logo.updated_logo_info = {
            ...logo_obj,
            ...getLogoUpdatedProps(response_data.result.customer_logo),
          };
          const logo_dimensions = response_data.result.logo_dimensions;
          logo.originalHeight_back = logo.originalHeight;
          logo.originalHeight =
            (parseFloat(logo_dimensions.height) / parseFloat(logo_dimensions.width)) *
            parseFloat(logo.originalHeight);

          showToast(response_data.message);
        } else {
          showToast(response_data.message, "info");
        }
        return logo;
      } catch (error) {
        handleResponseException(error);
        return null;
      } finally {
        --this.updating_logos_count;
        logo.show_loader = false;
      }
    },
    handleCancelUploadLogo(logo) {
      const updated_logo = logo.updated_logo_info;
      const remove_files = [
        updated_logo.url,
        updated_logo.original_logo,
        updated_logo.transparent_logo,
        updated_logo.smart_transparent_logo,
      ];
      logo.show_loader = true;
      ++this.updating_logos_count;
      http
        .post("remove-files-from-bucket", {
          logo_id: updated_logo.id,
          remove_files,
        })
        .then((successResponse) => {
          logo.updated_logo_info = null;
          if (logo.originalHeight_back) {
            logo.originalHeight = logo.originalHeight_back;
            delete logo.originalHeight_back;
          }
          logo.show_loader = false;
          --this.updating_logos_count;
          // Clear FileInputBox
          const file_uploader = `logo-upload-${logo.id}`;
          if (window.__globalFileInputRegistry && window.__globalFileInputRegistry[file_uploader]) {
            window.__globalFileInputRegistry[file_uploader].clearFile();
          }
        })
        .catch((errorResponse) => {
          logo.show_loader = false;
          --this.updating_logos_count;
          handleResponseException(errorResponse);
        });
    },
    place_holder(color_type) {
      if (color_type === "cmyk") {
        return "x,x,x,x";
      } else if (color_type === "pantone-coated") {
        return "xxx c";
      } else if (color_type === "pantone-tcx") {
        return "xx-xxxx";
      }
      return "";
    },
    handleSizeUpdate(event, roster_index, factory_product, is_custom_size=false) {
      let size_index = -1
      let selected_size = ""
      if(is_custom_size) {
        selected_size = event.target.value
      } else {
         size_index = event.target.value;
         selected_size = factory_product.product_sizes[size_index].name;
      }
      factory_product.product_roster_detail[roster_index].code = selected_size;
      factory_product.product_roster_detail[roster_index].size = selected_size;
      factory_product.product_roster_detail[roster_index].size_index = size_index;
      this.handleRosterUpdate(factory_product);
    },
    
    handleRosterUpdate(factory_product) {
      if (!("roster_summary" in factory_product)) {
        factory_product.roster_summary = { sizes: [], total_quantity: 0 };
      }

      const roster_detail_grouped_by_size = _.groupBy(
        factory_product.product_roster_detail,
        "size"
      );


      let product_summary = factory_product.roster_summary;
      product_summary.total_quantity = _.sumBy(
        factory_product.product_roster_detail,
        (roster_item) => {
          return parseInt(roster_item.quantity);
        }
      );
      product_summary.sizes = [];
      for (const size in roster_detail_grouped_by_size) {
        product_summary.sizes.push({
          name: size,
          quantity: _.sumBy(
            roster_detail_grouped_by_size[size],
            (roster_item_by_size) => {
              return parseInt(roster_item_by_size.quantity);
            }
          ),
        });
      }
      factory_product.roster_summary = product_summary;

      if (
        factory_product.product_price_object &&
        factory_product.price_list_detail
      ) {
        factory_product.product_price_object.quantity =
          factory_product.roster_summary.total_quantity;

        if (factory_product.price_list_detail.is_fixed) {
          factory_product.price_list_detail.subtotal =
            factory_product.price_list_detail.fixed_price *
            factory_product.product_price_object.quantity;
        } else {
          factory_product.price_list_detail.subtotal =
            factory_product.price_list_detail.discounted_price *
            factory_product.product_price_object.quantity;
        }

        factory_product.net_item_total =
          factory_product.price_list_detail.subtotal;

        if (factory_product.addons) {
          factory_product.addons.forEach((addon) => {
            if (addon.price_list_detail) {
              addon.price_list_detail.subtotal = addon.price_list_detail
                .is_fixed
                ? addon.price_list_detail.fixed_price *
                  factory_product.product_price_object.quantity
                : addon.price_list_detail.discounted_price *
                  factory_product.product_price_object.quantity;
            }
          });
        }
      }
    },
    extractExactCode(code, color_type = "pantone-tcx") {
      let pantone_coated = "";
      if (color_type === "pantone-coated") {
        const regex_numbers = /^[0-9]+/g;
        const regex_alphabets = /[a-zA-Z]+/g;
        const numbers = regex_numbers.exec(code);
        const alphabets = regex_alphabets.exec(code);
        if (numbers && numbers[0] && alphabets && alphabets[0]) {
          pantone_coated = numbers[0] + " " + alphabets[0].toUpperCase();
        }
      }
      return pantone_coated;
    },
    changeColor(
      e,
      color_type,
      svg_groups,
      svg_group,
      factory_product,
      gradient_color_index
    ) {
      const svg_group_colors = [];
      svg_groups.forEach((clr) => {
        if (clr.gradient_colors && clr.gradient_colors.length) {
          clr.gradient_colors.forEach((gradient_color) => {
            let svg_group_color = {
              hex: gradient_color.color,
              pantone: gradient_color.pantone,
              name: gradient_color.name,
            };
            svg_group_colors.push(svg_group_color);
          });
        } else {
          let svg_group_color = {
            hex: clr.color,
            pantone: clr.pantone,
            name: clr.name,
          };
          svg_group_colors.push(svg_group_color);
        }
      });
      if (e.hex) {
        let matched_color = getClosestColor(
          e.hex,
          svg_group_colors,
          color_type
        );
        if (matched_color) {
          this.changePantoneColor(
            matched_color.pantone,
            color_type,
            svg_group,
            factory_product,
            gradient_color_index
          );
        }
      }
    },
    changeTextColor(e, svg_groups, color_type, text_group, type) {
      const svg_group_colors = [];
      svg_groups.forEach((clr) => {
        if (clr.gradient_colors && clr.gradient_colors.length) {
          clr.gradient_colors.forEach((gradient_color) => {
            let svg_group_color = {
              hex: gradient_color.color,
              pantone: gradient_color.pantone,
              name: gradient_color.name,
            };
            svg_group_colors.push(svg_group_color);
          });
        } else {
          let svg_group_color = {
            hex: clr.color,
            pantone: clr.pantone,
            name: clr.name,
          };
          svg_group_colors.push(svg_group_color);
        }
      });
      if (e.hex) {
        let matched_color = getClosestColor(
          e.hex,
          svg_group_colors,
          color_type
        );
        if (matched_color) {
          this.changeTextPantoneColor(
            matched_color.pantone,
            color_type,
            text_group,
            type
          );
        }
      }
    },
    changePantoneColor(
      $event,
      color_type,
      svg_group,
      factory_product,
      gradient_index = null
    ) {
      const color_code = this.extractExactCode($event, color_type)
        ? this.extractExactCode($event, color_type)
        : $event;
      const pantoneColor = getColorEncoding(color_code, color_type);
      if (pantoneColor) {
        const selected_color = {
          name: pantoneColor.name,
          value: pantoneColor.hex,
          pantone: pantoneColor.pantone,
        };
        this.handleSvgGroupUpdate(
          factory_product,
          svg_group,
          selected_color,
          gradient_index
        );
        this.pantoneMessage = "";
      } else {
        this.pantoneMessage = "Color is not in the list.";
      }
    },
    changeTextPantoneColor($event, color_type, text_group, type = "fill") {
      const color_code = this.extractExactCode($event, color_type)
        ? this.extractExactCode($event, color_type)
        : $event;
      const pantoneColor = getColorEncoding(color_code, color_type);
      if (pantoneColor) {
        if (type === "outline") {
          text_group.outline_color = pantoneColor.hex;
          text_group.outline_color_pantone = pantoneColor.pantone;
        } else {
          text_group.color = pantoneColor.hex;
          text_group.color_pantone = pantoneColor.pantone;
        }
        this.pantoneMessage = "";
      } else {
        this.pantoneMessage = "Color is not in the list.";
      }
    },
    async getCompanies() {
      try {
        const successResponse = await http.get(`get-companies`)
        const response_data = successResponse.data
        this.companies = response_data.result
      } catch (errorResponse) {
        console.error(errorResponse)
        handleResponseException(errorResponse)
      }
    },

    async handleCompanyChange(companyId,customer_set_empty=true) {
      try {
        // Reset customer info
        if(customer_set_empty){
           this.customer_email = null
           this.showLoader = true
        }

        // Ensure companies list is loaded
        if (!this.companies || this.companies.length === 0) {
          try {
            await this.getCompanies()
          } catch (err) {
            console.warn('Failed to load companies before handling company change', err)
          }
        }

        this.order_data.company = this.companies.find(c => c.id === companyId)

        // Fetch manual-order-data (customers etc.)
        const successResponse = await http.get(`manual-order-data?company_id=${companyId}`)

        const response_data = successResponse.data
        this.customers = response_data.result.companies[0].customers ?? []

        // After fetching customers: restore or clear current customer selection
        const isOriginalCompany = companyId === this.order_data.original_company_id
        if (isOriginalCompany) {
          const defaultCustomer = this.customers.find(
            c => c.id === this.order_data.original_customer_id
          )
          if (defaultCustomer) {
            this.setCustomer(defaultCustomer)
          } else {
            this.order_data.customer_id = null
          }
        } else {
          if (!this.customers.find(c => c.id === this.order_data.customer_id)) {
            this.order_data.customer_id = null
          }
        }

        // Load merchant products via helper so we reuse existing logic
        try {
          await this.getMerchantProducts(companyId)
        } catch (e) {
          console.warn('Failed to load merchant products after company change', e)
          this.all_products = []
        }

        // For each factory product in the order: keep selection if exists under new merchant, otherwise reset via resetProduct
        if (this.order_data && Array.isArray(this.order_data.items)) {
          this.order_data.items.forEach((order_item) => {
            order_item.factory_products.forEach((factory_product) => {
              const selected_product = this.all_products.find(p => p.product_id === factory_product.product_id)
              if (selected_product) {

                // product still exists for this merchant update references and sizes
                factory_product.selected_product_obj = selected_product
                factory_product.product_name = selected_product.display_name || factory_product.product_name
                factory_product.product_sizes = selected_product.sizes && selected_product.sizes[0] ? selected_product.sizes[0].json_data : []
                if (selected_product.sku) {
                  factory_product.sku_number = selected_product.sku.sku_number || factory_product.sku_number
                  factory_product.sku_name = selected_product.sku.name || factory_product.sku_name
                }
                // Recalculate pricing using existing helper
                this.handleRosterUpdate(factory_product)
              } else {
                // Ensure consistent clearing using resetProduct helper
                this.resetProduct(factory_product)
                factory_product.product_sizes = []
              }
            })
          })
        }
      } catch (errorResponse) {
        console.error(errorResponse)
        handleResponseException(errorResponse)
      } finally {
        this.showLoader = false
      }
    },

    handleCustomerChange(customerId) {
      const selected = this.customers.find(c => c.id === customerId)
      if (selected) {
        this.setCustomer(selected)
        this.order_data.shipping_address =  this.nullAddress()
        this.customer_address = null;
      }
     
    },
    handleAddressChange(address) {
      const selected = this.customerAddresses.find(a => a.id === address.id)
      if (selected) {
        
        this.order_data.shipping_address =  this.fillAddress(selected)
      }
    },
    setCustomer(customer) {
      this.order_data.customer_id = customer.id
      this.order_data.customer_name = customer.first_name + ' ' + customer.last_name
      this.order_data.customer_email = customer.email
      this.customer_email = customer.email
      this.order_data.customer = customer
      this.customerAddresses = customer.addresses ?? []
    },
    nullAddress() {
      return {
        city: null,
        country: null,
        address1: null,
        address2: null,
        zip_code: null,
        last_name: null,
        first_name: null,
        phone_number: null,
        email: null,
        company_name: null,
        state: null,
      }
    },

    fillAddress(addr) {

      return {
        city: addr.city,
        country: addr.country.name,   
        address1: addr.address1,
        address2: addr.address2,
        zip_code: addr.zip_code,
        last_name: addr.last_name,
        first_name: addr.first_name,
        phone_number: addr.phone_number,
        email: addr.email || null,
        company_name: addr.company_name || null,
        state: addr.state || null,
      }
    },

    async getOrderData() {
      try {
        const url = `order/${this.order_id}/techpack`
        const successResponse = await http.get(url)

        const response_data = successResponse.data
        this.techpack_product_color_types =
          response_data?.result?.order?.product_color_types || {}
        this.order_data = this.formatOrderData(response_data.result.order)

        if (
          this.order_data &&
          this.order_data.additional_fields &&
          this.order_data.additional_fields.is_manual_order
        ) {
          this.is_manual_order = true
        }
        if (
          this.order_data &&
          this.order_data.additional_fields &&
          this.order_data.additional_fields.is_custom_design
        ) {
          this.is_custom_design = true;
          console.log('Mounted order data items:', this.order_data);
          this.order_data.items.forEach((order_item,order_index) => {
            order_item.factory_products.forEach((factory_product,factory_product_index) => {
              this.toggleCustomProduct(order_index,factory_product_index,false)
            })
          })
        }

        if (this.is_manual_order) {
          await this.addDynamicPropsToOrder()
        }

        this.original_order_data = santaClone(this.order_data)

        await this.getMerchantProducts(this.order_data.company_id)

        if (this.isWebComponent) {
          this.no_custimo_order = !response_data.success
        }

        this.showLoader = false
      } catch (errorResponse) {
        this.showLoader = false
        console.error(errorResponse)
        handleResponseException(errorResponse)
      }
    },

    formatOrderData(order_data) {
      order_data.items = order_data.items.map((order_item, order_item_index) => {
        this.available_factory_products_count =
          this.available_factory_products_count + order_item.items_count;
        this.order_factory_products_count =
          this.order_factory_products_count + order_item.items_count;
        order_item.factory_products.map((factory_product, factory_product_index) => {
          this.fontsList(factory_product.product_fonts);
          //add new property in custom logos to store new logo
          factory_product.custom_logos.map((custom_logo) => {
            custom_logo.show_loader = false;
            custom_logo.updated_logo_info = null;
            return custom_logo;
          });
          //add new property roster_index in the product_roster_detail
          factory_product.product_roster_detail.map(
            (product_roster_detail_item, product_roster_index) => {
              product_roster_detail_item.roster_index = product_roster_index;
              return product_roster_detail_item;
            }
          );
          //groupcolors should be object but sometime we get array
          if (
            factory_product.groupcolors &&
            factory_product.groupcolors.constructor.name == "Array"
          ) {
            factory_product.groupcolors = {};
          }
          //this will add new property roster_summary to factory_product
          this.handleRosterUpdate(factory_product);
          return factory_product;
        });
        return order_item;
      });
      return order_data;
    },
    makeArrayApart(array, items, logo_array = false) {
      // let newArray = array.filter((item)=>item.url ? item : false)
      // if(logo_array === false) {
      //   newArray = array
      // }
      const chunked_array = _.chunk(array, items);
      return chunked_array;
    },
    toggleColorPicker($event) {
      const color_pickers = document.querySelectorAll(".color_picker");
      color_pickers.forEach((item, index) => {
        item.classList.remove("active_picker");
      });

      $event.target.classList.add("active_picker");
    },
    async getGeneralSettings() {
      try {
        var self = this;
        let res = await this.$store.dispatch("getConfigurations");
        if (res.data.status_code === 200) {
          this.supported_languages = res.data.result.supported_languages;
          this.language_loading = false;
          this.general_form.language = res.data.result.selected_language;
          res.data.result.settings.forEach((setting) => {
            if (this.$can("view-general-settings")) {
              if (setting.key_name == "measurement_unit") {
                let label =
                  this.unit_labels.measurement_unit[setting.value.unit];
                self.general_form.measurement_unit = {
                  id: setting.value.unit,
                  label: label,
                };
              } else if (setting.key_name == "color_type") {
                let selected_option = this.color_type_options.filter(
                  (obj) => obj.id == setting.value
                );
                self.general_form.color_type.id = selected_option[0].id;
                self.general_form.color_type.label = selected_option[0].label;
              } else if (setting.key_name == "piping_text") {
                self.general_form.piping_text = setting.value;
              } else if (setting.key_name == "necktag_logo") {
                if (setting.value.url)
                  self.general_form.necktag_logo.url = setting.value.url;
                if (setting.value.file_id)
                  self.general_form.necktag_logo.file_id =
                    setting.value.file_id;
              } else if (setting.key_name == "logo_color_type") {
                let selected_option = this.color_type_options.filter(
                  (obj) => obj.id == setting.value
                );
                self.general_form.logo_color_type.id = selected_option[0].id;
                self.general_form.logo_color_type.label =
                  selected_option[0].label;
              } else if (setting.key_name == "shopify_setting") {
                if (setting.value.shopify_token)
                  self.general_form.shopify_setting.shopify_token =
                    setting.value.shopify_token;
                if (setting.value.shopify_store)
                  self.general_form.shopify_setting.shopify_store =
                    setting.value.shopify_store;
              } else if (setting.key_name == "woocommerce_setting") {
                if (setting.value.api_username)
                  self.general_form.woocommerce_setting.api_username =
                    setting.value.api_username;
                if (setting.value.api_password)
                  self.general_form.woocommerce_setting.api_password =
                    setting.value.api_password;
                if (setting.value.api_store_url)
                  self.general_form.woocommerce_setting.api_store_url =
                    setting.value.api_store_url;
                if (setting.value.admin_auth_url)
                  self.general_form.woocommerce_setting.admin_auth_url =
                    setting.value.admin_auth_url;
                if (setting.value.custimoo_plugin_api_secret)
                  self.general_form.woocommerce_setting.custimoo_plugin_api_secret =
                    setting.value.custimoo_plugin_api_secret;
              } else if (setting.key_name == "mail_receipients") {
                setting.value.forEach((email) => {
                  self.general_form.mail_recipients.push({
                    id: email,
                    label: email,
                  });
                });
              } else if (setting.key_name == "currencies") {
                if (setting.value) {
                  if (
                    Array.isArray(setting.value.currencies) &&
                    setting.value.currencies.length > 0
                  ) {
                    self.general_form.currency = [];
                    for (const currency of setting.value.currencies) {
                      self.general_form.currency.push({
                        id: currency,
                        label: currency,
                      });
                    }
                  }
                  self.display_msrp_in_builder = setting.value.visible;
                }
              } else if (setting.key_name == "msrp_label") {
                if (setting.value) {
                  if (setting.value.is_custom_msrp_label)
                    self.general_form.msrp_label.is_custom_msrp_label =
                      setting.value.is_custom_msrp_label;
                  if (setting.value.msrp_label)
                    self.general_form.msrp_label.msrp_label =
                      setting.value.msrp_label;
                  if (setting.value.msrp_label_admin) {
                    self.general_form.msrp_label.msrp_label_admin =
                      setting.value.msrp_label_admin;
                  }
                }
              } else if (setting.key_name == "msrp_label_admin") {
                if (setting.value) {
                  if (setting.value) {
                    self.general_form.msrp_label.msrp_label_admin =
                      setting.value;
                  }
                }
              } else if (this.$can("view-factory-settings")) {
                if (setting.key_name == "vector_image_constraint") {
                  let selected_option = this.vector_image_options.filter(
                    (obj) => obj.id == setting.value
                  );
                  self.factory_form.vector_image_required.id =
                    selected_option[0].id;
                  self.factory_form.vector_image_required.label =
                    selected_option[0].label;
                }
              }
            } else if (this.$can("view-superadmin-settings")) {
              if (setting.key_name == "msrp_label_admin") {
                if (setting.value) {
                  self.general_form.msrp_label.msrp_label_admin = setting.value;
                }
              }
            } else {
              this.showToast("Settings need to be set first", "ERROR");
            }
          });
        }
      } catch (err) {
        this.showErrors(err);
      }
    },
    resetTechPack() {
      this.order_data = santaClone(this.original_order_data);
      this.setFactoryProductsSelectedValues()
      this.available_factory_products_count = this.order_factory_products_count;
    },
    handleCustomTextHeightUpdate(event, custom_text) {
      const custom_text_original_height = custom_text.originalHeight
        ? parseFloat(custom_text.originalHeight)
        : 0;
      let custom_text_original_height_updated = custom_text_original_height;
      const custom_text_original_width = custom_text.originalWidth
        ? parseFloat(custom_text.originalWidth)
        : 0;
      let input_value = event.target.value ? parseFloat(event.target.value) : 0;
      if (input_value <= 0) {
        event.target.value = custom_text_original_height;
        input_value = custom_text_original_height;
      }
      let updated_value_in_percent = 0;
      custom_text_original_height_updated = input_value;
      custom_text.originalHeight = input_value;
      updated_value_in_percent =
        ((custom_text_original_height_updated - custom_text_original_height) /
          custom_text_original_height) *
        100;
      custom_text.originalWidth =
        custom_text_original_width +
        (updated_value_in_percent * custom_text_original_width) / 100;
      custom_text.scaleX =
        parseFloat(custom_text.scaleX) +
        (updated_value_in_percent * parseFloat(custom_text.scaleX)) / 100;
      custom_text.scaleY =
        parseFloat(custom_text.scaleY) +
        (updated_value_in_percent * parseFloat(custom_text.scaleY)) / 100;
    },
    handleDimensionsUpdate(
      event,
      target_object,
      measurement_ratio,
      update_type
    ) {
      let input_value = event.target.value ? parseFloat(event.target.value) : 0;
      if (
        !("originalWidth" in target_object) ||
        target_object.originalWidth <= 0
      ) {
        target_object.originalWidth = unitConversion(
          target_object.width * target_object.scaleX * measurement_ratio,
          this.order_data.company_settings.measurement_unit
        ).value;
      }
      if (
        !("originalHeight" in target_object) ||
        target_object.originalWidth <= 0
      ) {
        target_object.originalHeight = unitConversion(
          target_object.height * target_object.scaleY * measurement_ratio,
          this.order_data.company_settings.measurement_unit
        ).value;
      }
      const target_object_original_width = parseFloat(
        target_object.originalWidth
      );
      const target_object_original_height = parseFloat(
        target_object.originalHeight
      );
      let target_object_original_width_updated = target_object_original_width;
      let target_object_original_height_updated = target_object_original_height;
      //check if input value is empty or less than 0 then set previous value
      if (input_value <= 0) {
        if (update_type === "width") {
          event.target.value = target_object_original_width;
          input_value = target_object_original_width;
        } else {
          event.target.value = target_object_original_height;
          input_value = target_object_original_height;
        }
      }
      let updated_value_in_percent = 0;
      if (update_type === "width") {
        target_object_original_width_updated = input_value;
        target_object.originalWidth = parseFloat(input_value).toFixed(2);
        updated_value_in_percent =
          ((target_object_original_width_updated -
            target_object_original_width) /
            target_object_original_width) *
          100;
        target_object.originalHeight =
          target_object_original_height +
          (updated_value_in_percent * target_object_original_height) / 100;
        target_object.originalHeight = target_object.originalHeight.toFixed(2);
      } else {
        target_object_original_height_updated = input_value;
        target_object.originalHeight = parseFloat(input_value).toFixed(2);
        updated_value_in_percent =
          ((target_object_original_height_updated -
            target_object_original_height) /
            target_object_original_height) *
          100;
        target_object.originalWidth =
          target_object_original_width +
          (updated_value_in_percent * target_object_original_width) / 100;
        target_object.originalWidth = target_object.originalWidth.toFixed(2);
      }
      if ("scaleX" in target_object) {
        const { scaleX, scaleY } = target_object;
        target_object.scaleX =
          parseFloat(scaleX) +
          (updated_value_in_percent * parseFloat(scaleX)) / 100;
        target_object.scaleX = target_object.scaleX.toFixed(2);
        target_object.scaleY =
          parseFloat(scaleY) +
          (updated_value_in_percent * parseFloat(scaleY)) / 100;
        target_object.scaleY = target_object.scaleY.toFixed(2);
      } else {
        const { width, height } = target_object;
        target_object.width =
          parseFloat(width) +
          (updated_value_in_percent * parseFloat(width)) / 100;
        target_object.width = target_object.width.toFixed(2);
        target_object.height =
          parseFloat(height) +
          (updated_value_in_percent * parseFloat(height)) / 100;
        target_object.height = target_object.height.toFixed(2);
      }
    },
    handleRosterNameAndNumberUpdate(event, roster, factory_product) {
      const updated_key = event.target.type;
      const updated_value = event.target.value;
      roster[updated_key] = updated_value;
      if (roster.roster_index === 0) {
        const update_custom_text_index = updated_key === "text" ? 0 : 1;
        factory_product.product_custom_texts[update_custom_text_index].value =
          updated_value;
      }
    },
    addPlayer(factory_product) {
      let new_player = this.rosterDefaultObject(
        factory_product?.product_sizes[0]?.name || ''
      );
      if(factory_product.product_roster_detail && factory_product.product_roster_detail.length > 0) {
      const last_roster_player_index = factory_product.product_roster_detail.length - 1;
      new_player = {
         ...factory_product.product_roster_detail[last_roster_player_index],
          ...{
            text: "",
            number: "",
            quantity: 1,
            roster_index: last_roster_player_index + 1,
            information: ""
          }
         };
      }
      factory_product.product_roster_detail.push(new_player);

      this.handleRosterUpdate(factory_product);
    },
    copyRoster(factory_product){
      
      if(this.copiedRoster.isAnyRosterCopied){
        // show confirm modal

        let confirmText = "You already have a roster copied. Do you want to copy this product's roster instead?"
        this.$confirm(confirmText).then(async ()=>{
          // copy roster
          this.copiedRoster.isAnyRosterCopied = true;
          this.copiedRoster.rosterData = santaClone(factory_product.product_roster_detail);
          this.copiedRoster.copiedRosterFromId = factory_product.id;
          showToast("Roster copied. You can paste it now.","success");
        }).catch(e => {
          console.log(e);
        })
      }
      else{
        this.copiedRoster.isAnyRosterCopied = true;
        this.copiedRoster.rosterData = santaClone(factory_product.product_roster_detail);
        this.copiedRoster.copiedRosterFromId = factory_product.id;
        showToast("Roster copied. You can paste it now.","success");
      }
    },
    pasteRoster(factory_product){
        // paste roster
        factory_product.product_roster_detail = santaClone(this.copiedRoster.rosterData);
        // update roster index

        factory_product.product_roster_detail.forEach((rosterItem, index) => {
          rosterItem.roster_index = index;
          let matchedSize = '';
          factory_product.product_sizes.forEach((sizeObj) => {
            if(rosterItem.size == sizeObj.name){
              matchedSize = sizeObj.name;
            }
          });
          rosterItem.size = matchedSize 
        });

        this.handleRosterUpdate(factory_product);
        showToast("Roster pasted successfully.","success");
    },
    rosterDefaultObject(size) {
      return {
        code:size,
        information:null,
        number:null,
        quantity:1,
        roster_index:0,
        size:size,
        size_index:0,
        text:null
      }
    },
    deleteRow(roster_table_index, roster_index, factory_product) {
      factory_product.product_roster_detail[roster_table_index].splice(
        roster_index,
        1
      );
      this.handleRosterUpdate(factory_product);
    },
    handlePlayerDelete(factory_product, roster_index) {
      let factory_product_roster = santaClone(
        factory_product.product_roster_detail
      );
      factory_product_roster.splice(roster_index, 1);
      factory_product_roster.forEach(
        (factory_product_roster_item, factory_product_roster_index) => {
          factory_product_roster_item.roster_index =
            factory_product_roster_index;
        }
      );
      factory_product.product_roster_detail = factory_product_roster;
      this.handleRosterUpdate(factory_product);
    },
    handleFrontBackUpload(type, event, factory_product) {
      let update_info_key = "front_image_info";
      if (type === "back") {
        update_info_key = "back_image_info";
      }
      const file = event.target.files[0];
      if (file) {
        const file_extension = file.name.split(".").pop()?.toLowerCase();
        if (
          ["jpg", "jpeg", "pdf", "png", "ai", "eps", "svg"].includes(
            file_extension
          )
        ) {
          factory_product[update_info_key] = { updating: true };
          fileToBase64(file).then((response) => {
            factory_product[update_info_key] = {
              ...response,
              ...{ updating: false },
            };
          });
        } else {
          this.showToast("Please upload valid image", "error");
          const file_uploader = `factory-product-${factory_product.id}-${type}-uploader`;
          this.$refs[file_uploader][0].value = "";
        }
      } else {
        this.cancelFrontBackUpload(type, factory_product);
      }
    },
    cancelFrontBackUpload(type, factory_product) {
      let update_info_key =
        type === "front" ? "front_image_info" : "back_image_info";
      factory_product[update_info_key] = null;
      const file_uploader = `factory-product-${factory_product.id}-${type}-uploader`;
      // Clear FileInputBox if it exists
      if (window.__globalFileInputRegistry && window.__globalFileInputRegistry[file_uploader]) {
        window.__globalFileInputRegistry[file_uploader].clearFile();
      }
    },
    handleNeckTagLogoUpload(event, factory_product) {
      const file = event.target.files[0];
      if (file) {
        const file_extension = file.name.split(".").pop()?.toLowerCase();
        if (
          ["jpg", "jpeg", "png", "ai", "eps", "svg", "pdf"].includes(
            file_extension
          )
        ) {
          factory_product.neck_tag_info = { updating: true };
          fileToBase64(file).then((response) => {
            factory_product.neck_tag_info = {
              ...response,
              ...{ updating: false },
            };
          });
        } else {
          this.showToast("Please upload valid image", "error");
          const file_uploader = `factory-product-${factory_product.id}-neck-tag-logo`;
          this.$refs[file_uploader][0].value = "";
        }
      } else {
        this.cancelNeckTagLogoUpload(factory_product);
      }
    },
    cancelNeckTagLogoUpload(factory_product) {
      factory_product.neck_tag_info = null;
      const file_uploader = `factory-product-${factory_product.id}-neck-tag-logo`;
      // Clear FileInputBox if it exists
      if (window.__globalFileInputRegistry && window.__globalFileInputRegistry[file_uploader]) {
        window.__globalFileInputRegistry[file_uploader].clearFile();
      }
    },
    handleCarelabelUpload(event, factory_product) {
      const file = event.target.files[0];
      if (file) {
        const file_extension = file.name.split(".").pop()?.toLowerCase();
        if (
          ["jpg", "jpeg", "png", "ai", "eps", "svg", "pdf"].includes(
            file_extension
          )
        ) {
          factory_product.carelabel_info = { updating: true };
          fileToBase64(file).then((response) => {
            factory_product.carelabel_info = {
              ...response,
              ...{ updating: false },
            };
          });
        } else {
          this.showToast("Please upload valid image", "error");
          const file_uploader = `factory-product-${factory_product.id}-carelabel`;
          this.$refs[file_uploader][0].value = "";
        }
      } else {
        this.cancelCarelabelUpload(factory_product);
      }
    },
    cancelCarelabelUpload(factory_product) {
      factory_product.carelabel_info = null;
      const file_uploader = `factory-product-${factory_product.id}-carelabel`;
      // Clear FileInputBox if it exists
      if (window.__globalFileInputRegistry && window.__globalFileInputRegistry[file_uploader]) {
        window.__globalFileInputRegistry[file_uploader].clearFile();
      }
    },
    handleNeckTapeUpload(event, factory_product) {
      const file = event.target.files[0];
      if (file) {
        const file_extension = file.name.split(".").pop()?.toLowerCase();
        if (
          ["jpg", "jpeg", "png", "ai", "eps", "svg", "pdf"].includes(
            file_extension
          )
        ) {
          factory_product.neck_tape_info = { updating: true };
          fileToBase64(file).then((response) => {
            factory_product.neck_tape_info = {
              ...response,
              ...{ updating: false },
            };
          });
        } else {
          this.showToast("Please upload valid image", "error");
          const file_uploader = `factory-product-${factory_product.id}-neck-tape`;
          this.$refs[file_uploader][0].value = "";
        }
      } else {
        this.cancelCarelabelUpload(factory_product);
      }
    },
    cancelNeckTapeUpload(factory_product) {
      factory_product.neck_tape_info = null;
      const file_uploader = `factory-product-${factory_product.id}-neck-tape`;
      // Clear FileInputBox if it exists
      if (window.__globalFileInputRegistry && window.__globalFileInputRegistry[file_uploader]) {
        window.__globalFileInputRegistry[file_uploader].clearFile();
      }
    },
    handleLogoColorUpdate(custom_logo, logo_color_index, selected_color) {
      const updated_logo_color = {
        name: selected_color.name,
        hex: selected_color.value,
        pantone: "",
      };
      if (custom_logo.updated_logo_info) {
        this.$set(custom_logo.updated_logo_info.logo_colors, logo_color_index, {
          ...custom_logo.logo_colors[logo_color_index],
          ...updated_logo_color,
        });
      } else {
        this.$set(custom_logo.logo_colors, logo_color_index, {
          ...custom_logo.logo_colors[logo_color_index],
          ...updated_logo_color,
        });
      }
    },
    removeLogoColor(custom_logo, logo_color_index) {
      const color_default_object = { name: null, hex: null, pantone: "" };
      if (custom_logo.updated_logo_info) {
        this.$set(custom_logo.updated_logo_info.logo_colors, logo_color_index, {
          ...custom_logo.logo_colors[logo_color_index],
          ...color_default_object,
        });
      } else {
        this.$set(custom_logo.logo_colors, logo_color_index, {
          ...custom_logo.logo_colors[logo_color_index],
          ...color_default_object,
        });
      }
    },
    removePatternColor(group_patterns, group_pattern_index) {
      this.$delete(group_patterns, group_pattern_index); // Alternative
    },
    handleLogoColorPantoneUpdate(
      $event,
      color_type,
      custom_logo,
      logo_color_index
    ) {
      let updated_by = "input";
      if ($event && $event.constructor.name === "Object") {
        updated_by = "color_picker";
      }
      let updated_logo_color = {};
      if (updated_by === "input") {
        const color_code = this.extractExactCode($event, color_type)
          ? this.extractExactCode($event, color_type)
          : $event;
        const pantoneColor = getColorEncoding(color_code, color_type);
        if (pantoneColor) {
          updated_logo_color = {
            name: pantoneColor.name,
            hex: pantoneColor.hex,
            pantone: pantoneColor.pantone,
          };
        }
      } else {
        let closest_color = getClosestColor($event.hex, [], color_type);
        updated_logo_color = {
          name: closest_color.name,
          hex: closest_color.hex,
          pantone: closest_color.pantone,
        };
      }
      if (custom_logo.updated_logo_info) {
        this.$set(custom_logo.updated_logo_info.logo_colors, logo_color_index, {
          ...custom_logo.logo_colors[logo_color_index],
          ...updated_logo_color,
        });
      } else {
        this.$set(custom_logo.logo_colors, logo_color_index, {
          ...custom_logo.logo_colors[logo_color_index],
          ...updated_logo_color,
        });
      }
    },
    DeleteLogo(logo) {
      // Save logo ID before clearing it for FileInputBox cleanup
      const logoId = logo.id;
      logo.id = null;
      logo.original_logo = null;
      logo.original_logo_url = null;
      logo.smart_transparent_logo = null;
      logo.transparent_logo = null;
      logo.url = null;
      logo.logo_colors = [];
      logo.logo_name = "";
      // below are manually added properties to sync with method formatOrderData
      logo.show_loader = false;
      logo.updated_logo_info = null;
      // Clear FileInputBox if logo had an ID
      if (logoId !== null) {
        const file_uploader = `logo-upload-${logoId}`;
        if (window.__globalFileInputRegistry && window.__globalFileInputRegistry[file_uploader]) {
          window.__globalFileInputRegistry[file_uploader].clearFile();
        }
      }
    },
    removeBackImage(factory_product) {
      factory_product.back_image_info = null;
      factory_product.back_image = "";
      // Clear FileInputBox
      const file_uploader = `factory-product-${factory_product.id}-back-uploader`;
      if (window.__globalFileInputRegistry && window.__globalFileInputRegistry[file_uploader]) {
        window.__globalFileInputRegistry[file_uploader].clearFile();
      }
    },
    handleTextOutlineWidthUpdate(
      event,
      product_custom_text_item,
      measurement_ratio
    ) {
      let input_value = event.target.value
        ? parseFloat(event.target.value).toFixed(2)
        : 0;
      let original_outline_width = parseFloat(
        product_custom_text_item.outline_width
      );
      let original_outline_width_converted = parseFloat(
        product_custom_text_item.outline_width_converted
      ).toFixed(2);
      if (input_value <= 0) {
        event.target.value = original_outline_width_converted;
        input_value = original_outline_width_converted;
        return false;
      }
      product_custom_text_item.outline_width_converted = input_value;
      let updated_value_in_percent = 0;
      if (
        original_outline_width_converted &&
        original_outline_width_converted > 0
      ) {
        updated_value_in_percent =
          ((input_value - original_outline_width_converted) /
            original_outline_width_converted) *
          100;
      } else {
        updated_value_in_percent = input_value;
      }
      product_custom_text_item.outline_width =
        original_outline_width +
        original_outline_width * (updated_value_in_percent / 100);
      product_custom_text_item.outline_width = parseFloat(
        product_custom_text_item.outline_width
      ).toFixed(1);
      if (product_custom_text_item.outline_width > 10) {
        product_custom_text_item.outline_width = 10.0;
      }
    },
    async setFactoryProductSelectedCustomizedAddons(factory_product) {
      factory_product.grouped_addons = {};
      factory_product.ungrouped_addons = [];

      const { styles, style_id } = factory_product;
      const style_index = _.findIndex(styles, (style) => style.id == style_id);
      if (style_index >= 0) {
        const selected_style = styles[style_index];
        const { grouped_addons, ungrouped_addons } =
          selected_style.customized_addons;
        for (const group_name in grouped_addons) {
          const selected_grouped_addon = _.find(
            grouped_addons[group_name],
            (grouped_addon) => grouped_addon.selected
          );
          if (selected_grouped_addon) {
            factory_product.grouped_addons[group_name] = selected_grouped_addon;
          }
        }
        factory_product.ungrouped_addons = _.filter(
          ungrouped_addons,
          (ungrouped_addon) => ungrouped_addon.selected
        );
      }
    },
    handleCustomizedAddonsUpdate(
      selected_val,
      factory_product_style,
      addon_index,
      group_name
    ) {
      //if any one grouped addon selected then make sure to un select all other addons of that group
      if (selected_val) {
        factory_product_style.customized_addons.grouped_addons[
          group_name
        ].forEach((updated_group_addon, ugaIdx) => {
          if (ugaIdx !== addon_index) {
            updated_group_addon.selected = false;
          }
        });
      }
    },
    formatPatternData(group_pattern) {
      const { color, ...filteredData } = group_pattern;
      // Convert to comma-separated values
      return Object.entries(filteredData)
        .map(
          ([key, value]) => `${this.capitalize(key)}: ${this.capitalize(value)}`
        )
        .join(", ");
    },
    capitalize(str) {
      return (
        str && str.toString().charAt(0).toUpperCase() + str.toString().slice(1)
      );
    },
    removeOrRestoreFactoryProduct(factory_product, action = "remove") {
      const is_deleted = action === "remove";
      factory_product.is_deleted = is_deleted;
      if (is_deleted) {
        --this.available_factory_products_count;
      } else {
        ++this.available_factory_products_count;
      }
    },
    fontsList(product) {
      const productFonts = product;
      if (productFonts && productFonts.length) {
        const item = productFonts[0].json_data;
        if (item) {
          this.fontOptions = [];
          item.forEach((fonts, key) => {
            let fontNameParam = fonts.path.split("/").reverse();
            fontNameParam = fontNameParam[0].split(".");
            const fontName = fontNameParam[0].replace("-", " ").toUpperCase();
            const font = {
              value: fontNameParam[0],
              text: fontName,
            };
            let hasMatch = false;
            for (let index = 0; index < this.fontOptions.length; ++index) {
              const obj = this.fontOptions[index];
              if (obj.text == font.text) {
                hasMatch = true;
                break;
              }
            }
            if (!hasMatch) {
              this.fontOptions.push(font);
            }
            const fontUrl = this.storageUrl + "/" + fonts.path;
            const headElement = document.querySelector("head");
            const style_tag = document.createElement("style");
            style_tag.innerHTML =
              "@font-face{font-family: " +
              font.value +
              "; src: url('" +
              fontUrl +
              "')}";
            headElement.appendChild(style_tag);
          });
        }
      }
    },
    resetInvalidStyle(order_item_index, factory_product_index) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      const selectedStyle = factory_product.selected_style_obj;
      const selected_style_name = selectedStyle?.name 
      const currentStyle =
        factory_product.selected_product_obj?.productstyles?.find(
          (style) => style.name === selected_style_name
        );

      if (currentStyle) {
        factory_product.style_id = currentStyle.id
        factory_product.style_name = currentStyle.name
        factory_product.selected_style_obj = currentStyle
        factory_product.design_id = null
        factory_product.design_name = null
      } else {
        const items = this.order_data.items[0].factory_products;
        const idx = items.findIndex(
          (p) => p.product_name === factory_product.product_name
        );
        if (idx !== -1) {
          const updated = {
            ...factory_product,
            selected_style_obj: null,
            style_id: null,
            style_name: null,
            design_id: null,
            design_name: null,
          };
          this.order_data.items[0].factory_products.splice(idx, 1, updated);
        }
      }
      this.showSelectedProductAddons(order_item_index, factory_product_index)
    },
    resetInvalidDesign(factory_product) {
      const selectedDesign = factory_product.design_name;
      const currentDesign =
        factory_product.selected_style_obj?.productdesigns?.find(
          (design) => design.design_name === selectedDesign
        );

      if (!currentDesign) {
        const items = this.order_data.items[0].factory_products;
        const idx = items.findIndex(
          (p) => p.product_name === factory_product.product_name
        );
        if (idx !== -1) {
          const updated = {
            ...factory_product,
            design_id: null,
            design_name: null,
            svg_groups: [], // Reset svg_groups when design is reset
          };
          this.order_data.items[0].factory_products.splice(idx, 1, updated);
        }
      }
    },
    async getMerchantProducts(company_id) {
      try {
        const successResponse = await http.get(`merchant_products?company_id=${company_id}`)
        this.all_products = successResponse.data.result.products || [];
        this.setFactoryProductsSelectedValues()
        return this.all_products
      } catch (err) {
        this.all_products = []
        throw err
      }
    },
  addSvgGroup(factory_product) {

    const jsonData = factory_product?.product_colors?.[0]?.json_data ?? [];
    const blackColor = jsonData.find(
      color => color?.value?.trim().toLowerCase() === "#000000"
    ) ?? null;

    factory_product.svg_groups.push(
      this.getSvgGroup({
        color: blackColor?.value ?? null,
        name:  blackColor?.name  ?? null,
        is_custom: true
      })
    );
  },
    /**
     * Merges updated SVG group values with defaults.
     * @param {Object} updated_values - Partial group properties to override.
     * @returns {{ color: string|null, count: number, id: string|null, name: string|null, pantone: string|null, is_custom: boolean }}
     */
    getSvgGroup(updated_values) {
    
      const svg_group_default_item = { color:"#000000", count:1, id: null, name:null, pantone:null, is_custom: false }
      return { ...svg_group_default_item, ...updated_values}
    },
    uploadProductAssets(event, order_item_index, factory_product_index) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      const factory_product_assets_input = this.$refs[`factory-product-${factory_product.id}-order-${order_item_index}-assets-ref`]?.[0]
       if(event.target.files.length > 0) {
        const factory_product_default_object = this.getAssetsDefaulObject()
        Array.from(event.target.files).forEach(uploaded_asset => {
          const factory_product_default_obj = this.getAssetsDefaulObject()
          factory_product_default_obj.updating = true
          factory_product_default_obj.file = uploaded_asset
          factory_product_default_obj.original_name = uploaded_asset.name
          factory_product_default_obj.file_size = uploaded_asset.size
          factory_product_default_obj.extension = uploaded_asset.name.split('.').pop().toLowerCase()
          this.order_data.items[order_item_index].factory_products[factory_product_index].assets_info.push(factory_product_default_obj)
           fileToBase64(uploaded_asset).then((response) => {
              factory_product_default_obj.base64_file = response.base64String;
              factory_product_default_obj.updating = false
            });
        })
    }
    },
    async addDynamicPropsToOrder() {
      this.order_data.items.forEach((order_item, orderItemIndex) => {
        order_item.factory_products.forEach((factory_product, factoryProductIndex) => {
          if (!Object.prototype.hasOwnProperty.call(factory_product, 'assets_info')) {
            let factory_product_assets = factory_product.assets;

            if (Array.isArray(factory_product_assets) && factory_product_assets.length > 0) {
              factory_product_assets = factory_product_assets
                .filter(factory_product_asset => factory_product_asset.path) // filter assets with no path
                .map(factory_product_asset => ({
                  ...this.getAssetsDefaulObject(), ...factory_product_asset
                }));
            } else {
              factory_product_assets = [];
            }
            this.$set(
              this.order_data.items[orderItemIndex].factory_products[factoryProductIndex],
              "assets_info", 
              factory_product_assets
            );
          }
        });
      });
    },
    /**
     * @typedef {Object} AssetInfo
     * @property {string} extension
     * @property {File} file
     * @property {number|string} file_size
     * @property {boolean} is_deleted
     * @property {string} name
     * @property {string} original_name
     * @property {string} path
     * @property {boolean} updating
     * @property {string} base64_file
     */

    /**
     * @returns {AssetInfo}
     */
    getAssetsDefaulObject() {
      return { extension: null, file: null, file_size: null, is_deleted: false, name: null, original_name: null, path: null, updating: false, base64_file: null  }
    },
    removeAsset(order_item_index, factory_product_index, asset_index) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      let deleted_asset = factory_product.assets_info[asset_index]
      if(deleted_asset.base64_file) {
        factory_product.assets_info.splice(asset_index, 1)
      } else {
        deleted_asset.is_deleted = true
      }
      // Clear the uploader filename when user deletes an asset
      const registryKey = `factory-product-${factory_product.id}-order-${order_item_index}-assets-ref`;
      if (window.__globalFileInputRegistry && window.__globalFileInputRegistry[registryKey]) {
        window.__globalFileInputRegistry[registryKey].clearFile();
      }
    },
    undoDelete(order_item_index, factory_product_index, asset_index) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      let deleted_asset = factory_product.assets_info[asset_index]
        deleted_asset.is_deleted = false
    },
    getDefaultCustomText(updated_values = {}) {
      return {
        id: null,
        product_id: null,
        type: "", //name, number
        label: "", // Player Name, Player Number
        following_products: [],
        items: [
          {
            label: "Player Name",
            height: "1",
            x_axis: 250,
            y_axis: 250,
            rotation: 0,
            is_locked: false,
            placement: "Front",
            outline_enabled: true,
            arc_text_allowed: 1,
            font_family: "",
            color: "",
            color_pantone: "White",
            outline_width: 0,
            outline_width_converted: 0,
            color_tab_index: 0,
            outline_color: "",
            outline_color_pantone: "",
            selected: true,
            scaleX: 0,
            scaleY: 0,
            width: 0,
            actualWidth: 0,
            actualHeight: 0,
            originalWidth: 0,
            originalHeight: 0
          }
        ],
        created_at: null,
        updated_at: null,
        deleted_at: null,
        value: "",
        manually_added: false,
        font_family: "",
        following_product_ids: [],
        active_item_index: 0,
        font_family_custom: "",
        is_first_name: false
  }
    },
    addCustomText(order_item_index, factory_product_index) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      const factory_product_custom_texts_count = factory_product.product_custom_texts.length
      let product_custom_text = null
      let product_custom_text_updated_keys = {type: ""}
      if(factory_product_custom_texts_count === 0) {
        product_custom_text = factory_product.product_texts[0] || this.getDefaultCustomText()
        product_custom_text_updated_keys.type = "name"
      } else {
        //get custom text from product
        if(factory_product.product_texts[factory_product_custom_texts_count]) {
          product_custom_text = factory_product.product_texts[factory_product_custom_texts_count] || null
        } 
        if(factory_product_custom_texts_count === 1) {
          product_custom_text_updated_keys.type = "number"
        } else if(factory_product_custom_texts_count >= 2) {
          product_custom_text_updated_keys.type = "fixed_text"
        }
        //if custom text not found from prduct
        if(!product_custom_text) {
          product_custom_text = this.getDefaultCustomText();
        }
        if(!product_custom_text.type) {
          product_custom_text.type = "name"
        }
        if(!product_custom_text.label) {
          product_custom_text.type = "Name"
        }
        if(factory_product_custom_texts_count === 1) {
          product_custom_text.type = "number"
          product_custom_text.label = "Number"
        }
      
        if(factory_product_custom_texts_count >= 2) {
          product_custom_text.label = `Fixed Text ${factory_product_custom_texts_count}`
          product_custom_text.items = [product_custom_text.items[0]]
        }
        }
        factory_product.product_custom_texts.push(santaClone(product_custom_text))
    },
    removeCustomText(order_item_index, factory_product_index, product_custom_text_index) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      factory_product.product_custom_texts.splice(product_custom_text_index, 1);

    },
    toggleCustomProduct(order_item_index, factory_product_index, is_custom_product) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      if(is_custom_product) {
        this.order_data.items[order_item_index].factory_products[factory_product_index].svg_groups = [];
        this.setProductSizes(order_item_index, factory_product_index)
        // this.resetProduct(factory_product)
      } else {
        this.setProductSizes(order_item_index, factory_product_index)
        if(factory_product.product_sizes && factory_product.product_sizes.length > 0) {
          factory_product.product_roster_detail.forEach((roster_item) => {
            roster_item.size = factory_product.product_sizes[0].name;
            roster_item.code = factory_product.product_sizes[0].name;
            roster_item.size_index = 0;
          });
        }
      }
    },
    handleProductUpdate_back(order_item_index, factory_product_index, selected_product) {
      if(selected_product) {
        this.$refs[`order-item-${order_item_index}factory-product-${factory_product_index}-product-options`][0].internalValue  = selected_product.name_by_sku;
        const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
        factory_product.selected_product_obj = selected_product;
        factory_product.product_id = selected_product.product_id;
        factory_product.product_sizes = selected_product.sizes[0].json_data
      }
      
      this.showSelectedProductAddons(order_item_index, factory_product_index)
      this.resetInvalidStyle(order_item_index, factory_product_index)
    },
    handleProductUpdate(order_item_index, factory_product_index, selected_product) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      factory_product.product_id = selected_product.product_id;
      factory_product.product_name = selected_product.display_name;
      this.setProductSizes(order_item_index, factory_product_index)
      this.showSelectedProductAddons(order_item_index, factory_product_index);      
      this.resetStyle(factory_product)
      const { sizes: selected_product_sizes } = factory_product.selected_product_obj;
      const {product_roster_detail: rosters} = factory_product;
      const sizesMap = selected_product_sizes[0]?.json_data?.map(data=> data.name);
      const updated_roster = rosters.map((roster, index)=>{
        const rowSize = sizesMap.some(size => size.trim().toLowerCase() === roster?.size?.trim().toLowerCase()) ? roster.size : null;
        return {
          ...roster,
          size: rowSize
        }
      })
      factory_product.product_roster_detail = updated_roster;
      //this.resetInvalidStyle(order_item_index, factory_product_index)
    },
    resetProduct(factory_product) {
      factory_product.product_id = null
      factory_product.product_sizes = []
      factory_product.selected_product_obj = null
      factory_product.product_name = ""
      factory_product.sku_name = ""
      factory_product.sku_number = null
      factory_product.addons = []
      factory_product.grouped_addons = {}
      factory_product.ungrouped_addons = []
      this.resetStyle(factory_product)
      this.resetDesign(factory_product)
    },
    setProductSizes(order_item_index, factory_product_index) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      if(factory_product.is_custom_product && !this.is_custom_design) {
        factory_product.product_sizes = []
      } else {
        const selected_product = this.all_products.find(product => product.product_id === factory_product.product_id)
        if(selected_product) {
          factory_product.product_sizes = selected_product.sizes[0].json_data
        } else {
          factory_product.product_sizes = []
        }
      }
    },
    resetStyle(factory_product) {      
      factory_product.selected_style_obj = null
      factory_product.style_id = null
      factory_product.style_name = null
      factory_product.grouped_addons = {}
      factory_product.ungrouped_addons = []
      this.resetDesign(factory_product)
    },
    resetDesign(factory_product) {
      factory_product.design_name = null
      factory_product.design_id = null
      factory_product.svg_groups = [] // Reset svg_groups when design is reset
    },
    showSelectedProductAddons(order_item_index, factory_product_index) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      const selected_product = this.all_products.find(product => product.product_id === factory_product.product_id) 
      if(selected_product) {
        const original_factory_product = this.getOriginalFactoryProductFromId(order_item_index, factory_product.id)
        let product_original_addons = []
        // For newly added products, original_factory_product will be null, so use current addons
        if(original_factory_product) {
          product_original_addons = original_factory_product.addons
        } else {
          // Use current factory_product's addons for newly added products
          product_original_addons = factory_product.addons || []
        }
        factory_product.addons = selected_product.active_addons.map(active_addon => {
          // Clone the addon to avoid mutations
          const addon_copy = { ...active_addon, selected: false }
          const original_addons = product_original_addons.find(original_addon => original_addon.addon_id === active_addon.addon_id)
          if(original_addons) {
            addon_copy.selected = original_addons.selected
          }
          return addon_copy
        })
        const selected_style_id = factory_product.style_id
        const selected_style_index = selected_product.productstyles.findIndex(style => style.id === selected_style_id)
        const selected_style = selected_product.productstyles[selected_style_index] || null
        if(selected_style){ 
          // Clone customized_addons to avoid direct reference mutation
          const customized_addons = JSON.parse(JSON.stringify(selected_style.customized_addons))
          //this will have group name and selected addon of group.
          // FIX: Check if original_factory_product exists before accessing properties
          const original_addons_by_group = original_factory_product && Object.prototype.hasOwnProperty.call(original_factory_product, 'grouped_addons') ? original_factory_product.grouped_addons : {}
          const original_factory_product_ungrouped_addons = original_factory_product && Object.prototype.hasOwnProperty.call(original_factory_product, 'ungrouped_addons') ?  original_factory_product.ungrouped_addons : []
            // Re-assign ungrouped_addons with selected info - default to false
          customized_addons.ungrouped_addons = customized_addons.ungrouped_addons.map(ungrouped_addon => {
            ungrouped_addon.selected = false // Reset to false by default
            const original_ungrouped_addon = original_factory_product_ungrouped_addons.find(original_ungrouped_addon => original_ungrouped_addon.addon_id === ungrouped_addon.addon_id)
            if(original_ungrouped_addon) {
              ungrouped_addon.selected = original_ungrouped_addon.selected
            }
            return ungrouped_addon
          })
          //handle grouped addons - reset all to false first
          for(const[group_name, group_addons] of Object.entries(customized_addons.grouped_addons)) {
            const original_group_selected_addon = original_addons_by_group[group_name] || null
            customized_addons.grouped_addons[group_name] = group_addons.map(grouped_addon => {
                grouped_addon.selected = false // Reset to false by default
                if(original_group_selected_addon && grouped_addon.addon_id === original_group_selected_addon.addon_id) {
                  grouped_addon.selected = true
                }
                return grouped_addon
              })
          }
          selected_product.productstyles[selected_style_index].customized_addons = customized_addons;
          factory_product.styles = selected_product.productstyles
        }
      } else {
        factory_product.addons = []
        factory_product.styles = []
        factory_product.grouped_addons = {}
        factory_product.ungrouped_addons = []
      }
    },
    getOriginalFactoryProductFromId(order_item_index, factory_product_id) {
      const factory_product = find(this.original_order_data.items[order_item_index].factory_products, ["id", factory_product_id]);
      // Return null if product doesn't exist (newly added products won't be in original_order_data)
      if (!factory_product) {
        return null;
      }
      return santaClone(factory_product);
    },
    handleStyleUpdate(order_item_index, factory_product_index, selected_style) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      factory_product.style_id = selected_style.id;
      factory_product.style_name = selected_style.name;
      this.resetInvalidDesign(factory_product);
      this.showSelectedProductAddons(order_item_index, factory_product_index)
    },
      handleDesignUpdate(order_item_index, factory_product_index, selected_design) {
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      // Take the original name and design (if any)
      let baseName = factory_product.product_name

      // If we previously stored design_name, strip it out from product_name
      if (factory_product.design_name) {
        // remove trailing " - oldDesignName" safely
        const suffix = ` - ${factory_product.design_name}`
        if (baseName.endsWith(suffix)) {
          baseName = baseName.slice(0, -suffix.length)
        }
      }

      // Update design_name and product_name
      factory_product.design_name = selected_design.design_name
      factory_product.product_name = `${baseName} - ${selected_design.design_name}`
      factory_product.design_id = selected_design.id;
      if(this.is_manual_order && !factory_product.is_custom_product) {
        const svg_parts = selected_design.svg_parts;
        if (svg_parts && svg_parts.length > 0) {
          factory_product.svg_groups = svg_parts.map((svg_part) => ({
            ...this.getSvgGroup(), ...{ id: svg_part,  count: svg_part === "base" ? 9999 : 1 }
          }));
        }
      }
    },
    getProductLogoDefaultObject(default_values) {
      const default_obj =  { id: null, product_id: null, product_style_id: null, following_product_ids: null, rotation: 0,
        originalWidth: 57, originalHeight: 57, width: 57, height: 57, name_of_placement: "chest", side: "front", x_axis: 300,
        y_axis: 300, x_axis_3d: 0, y_axis_3d: 0, is_locked: false, logo_name: null, original_logo: null, transparent_logo: null,
        smart_transparent_logo: null, original_logo_url: null, is_smart_transparent: null, url: null, haveControls: true,
        logo_colors: [], is_replace_success: false, logo_index: 0, is_vector: false, logo_technology: {}
      }
      return {...default_obj, ...default_values}
    },
    async UploadProductLogo(event, order_item_index, factory_product_index) {
      const file = event.target.files?.[0];
      if (!file) return;
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index]
      const factory_product_custom_logos = factory_product.custom_logos 
      const product_logos_count = factory_product_custom_logos.length
      const product_logos_setting = factory_product.logos_setting
      let logo_setting = null
      if(product_logos_count === 0) {
        logo_setting = product_logos_setting[0] || null;
      } else {
        logo_setting = product_logos_setting[product_logos_count] || null;
      }
      let uploaded_logo_props = logo_setting ? this.getProductLogoDefaultObject(logo_setting) : this.getProductLogoDefaultObject()
      //add custom props that are being added in method formatOrderData for custom logos
      uploaded_logo_props = {...uploaded_logo_props, show_loader: false, updated_logo_info: null, is_manual: true}
      factory_product.custom_logos.push(uploaded_logo_props);
      const uploaded_logo = await this.uploadLogo(file, uploaded_logo_props);
      if(uploaded_logo) {
        factory_product.custom_logos[factory_product.custom_logos.length -1] = uploaded_logo;
      } else {
        factory_product.custom_logos.splice(factory_product.custom_logos.length -1, 1)
      }
      event.target.value = "";
    },
    setFactoryProductsSelectedValues() {

      this.order_data.items.forEach((order_item, order_item_index) => {
        order_item.factory_products.forEach((factory_product, factory_product_index) => {
          // Find the product in all_products by product_id
          const selected_product = this.all_products.find(
            (product) => product.product_id === factory_product.product_id
          );
          if (selected_product) {
            // Set the selected_product_obj so v-select shows the correct default
            this.$set(factory_product, 'selected_product_obj', selected_product);
          } else {
            this.$set(factory_product, 'selected_product_obj', null);
          }
        });
      });
    },
    vSelectTriggerInputEvent(v_select_ref, value) {
      if(value) {
        v_select_ref.select(value);
      } else {
        v_select_ref.clearSelection();
      }
      // These two help close the dropdown
      v_select_ref.search = '';
      v_select_ref.open = false;
      this.$nextTick(() => {
        if (v_select_ref.$refs.search) {
          v_select_ref.$refs.search.blur?.();
        }
      });
    },

    async downloadTemplate(product_id, product_name) {
      await http.get(`template/download/${product_id}`, {
        responseType: 'blob',
      }).then((res) => {
        const blob = new Blob([res.data], {type: res.headers['content-type']})
        const custom_document = getDomDocument(true);
        const link = custom_document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'product_' + product_name + '_template.xlsx';
        link.click();
      })
    },

    async handleRosterUpload($event, order_item_index, factory_product_index){
      const factory_product = this.order_data.items[order_item_index].factory_products[factory_product_index];
      const { sizes: selected_product_sizes } = factory_product.selected_product_obj;
      if($event) {
        const file = $event.target.files[0];
        const ext = file.name.split('.').pop();
        const updated_roster = []
        if (ext != 'xlsx'){
          alert("The Excel file that was uploaded cannot be read, or it does not adhere to the template format. Please download the Excel template located next to the upload field, input your data there, and then attempt the upload again.");
          this.showLoader = false;
          event.target.value = null;
          return false
        }
        let check_cols = false;

        readXlsxFile(file).then((rows) => {
          check_cols = rows[0][0] == 'NAME ON PRODUCT' && rows[0][1] == 'NUMBER' && rows[0][2] == 'SIZE*' && rows[0][3] == 'QUANTITY*'
          if (rows[0].length != 4 && rows[0].length != 6){
            alert("The Excel file that was uploaded cannot be read, or it does not adhere to the template format. Please download the Excel template located next to the upload field, input your data there, and then attempt the upload again.");
            this.showLoader = false;
            $event.target.value = null;
            return false
          }else if(rows.length < 2){
            alert("The excel file has no data in it");
            this.showLoader = false;
            $event.target.value = null;
            return false
          }else if(check_cols){
            const sizesMap = selected_product_sizes[0]?.json_data?.map(data=> data.name);
            rows.forEach((row, index)=>{
              if(index){
                const typeof_number = typeof row[1];
                if(typeof_number === "number") {
                  row[1] = row[1].toString();
                }
                //object type means the value is null
                if(typeof_number === "object") {
                  row[1] = '';
                }
                if(row[1].constructor.name == "Number") {
                  row[1] = row[1].toString()
                }
                const rowSize = sizesMap.some(size => size.trim().toLowerCase() === row[2].trim().toLowerCase()) ? row[2] : null;
                const roster = {
                  "text": row[0],
                  "number": row[1],
                  "size": rowSize,
                  "quantity": row[3],
                  "information": ""
                }
                updated_roster.push(roster)
              }
            })
            factory_product.product_roster_detail = updated_roster
            this.handleRosterUpdate(factory_product)
            $event.target.value = null;
          }
          else{
            this.showLoader = false;
            $event.target.value = null;
          }
          this.showToast('Excel file uploaded successfully', 'SUCCESS');
          $event.target.value = null;
        })
      }
    },
    collectFileFields() {
      // Use the global FileInputBox registry to collect all file fields
      this.fileFields = [];
      if (window.__globalFileInputRegistry) {
        for (const key in window.__globalFileInputRegistry) {
          const comp = window.__globalFileInputRegistry[key];
          if (comp && comp.label) {
            this.fileFields.push({ ref: key, label: comp.label });
          }
        }
      }
      
      // Group fields by product
      this.groupFileFieldsByProduct();
    },
    groupFileFieldsByProduct() {
      this.fileFieldsByProduct = [];
      
      if (!this.order_data || !this.order_data.items) {
        return;
      }
      
      // Create a map to store product groups, keyed by product ID
      const productMap = new Map();
      
      // First pass: create product groups
      this.order_data.items.forEach((orderItem, orderItemIndex) => {
        orderItem.factory_products.forEach((factory_product, factory_product_index) => {
          const productId = factory_product.id;
          const productName = factory_product.product_name || 
                             factory_product.selected_product_obj?.name || 
                             factory_product.new_product_name ||
                             `Product ${factory_product_index + 1}`;
          
          // Initialize product group if not exists
          if (!productMap.has(productId)) {
            productMap.set(productId, {
              productId: productId,
              productName: productName,
              fields: [],
              isOpen: false, // Will be set to true for first product
            });
          }
        });
      });
      
      // Second pass: assign fields to products
      this.fileFields.forEach(field => {
        // Try to match by product ID first (more reliable)
        let matched = false;
        for (const [productId, productGroup] of productMap.entries()) {
          if (field.ref.includes(`factory-product-${productId}-`)) {
            productGroup.fields.push(field);
            matched = true;
            break;
          }
        }
        
        // If not matched by ID, try to match by index (for fields like assets-ref, logos-ref)
        if (!matched) {
          this.order_data.items.forEach((orderItem, orderItemIndex) => {
            orderItem.factory_products.forEach((factory_product, factory_product_index) => {
              const productId = factory_product.id;
              const productGroup = productMap.get(productId);
              
              // Match fields that use factory_product_index instead of product ID
              if (field.ref.includes(`factory-product-${factory_product_index}-`) && 
                  productGroup && 
                  !productGroup.fields.find(f => f.ref === field.ref)) {
                productGroup.fields.push(field);
              }
            });
          });
        }
      });
      
      // Convert map to array, filter out empty groups, and sort by product ID
      this.fileFieldsByProduct = Array.from(productMap.values())
        .filter(group => group.fields.length > 0) // Only include groups with fields
        .sort((a, b) => a.productId - b.productId);
      
      // Open first product by default
      if (this.fileFieldsByProduct.length > 0) {
        this.fileFieldsByProduct[0].isOpen = true;
      }
    },
    onFileInputClick(refName) {
      // Remember this as the current paste target when a FileInputBox is focused
      this.currentPasteFieldRef = refName;
      this.collectFileFields();
    },
    onFileInputBlur(refName) {
      // Clear the paste target when a FileInputBox loses focus
      // Only clear if it's the currently selected field
      if (this.currentPasteFieldRef === refName) {
        // Use setTimeout to allow the click event to complete first
        // This prevents clearing when clicking on another file input
        setTimeout(() => {
          // Check if the active element is still not a file input box
          const active = document.activeElement;
          const isFileInputBox = active && active.closest('.file-input-box');
          if (!isFileInputBox) {
            this.currentPasteFieldRef = null;
          }
        }, 100);
      }
    },
    handleDocumentClick(e) {
      // Clear currentPasteFieldRef if clicking outside any file input box
      const clickedFileInputBox = e.target.closest('.file-input-box');
      if (!clickedFileInputBox && this.currentPasteFieldRef) {
        this.currentPasteFieldRef = null;
      }
    },
    handleGlobalPaste(e) {
      // Always refresh available fields before handling paste
      this.collectFileFields();
      const items = e.clipboardData && e.clipboardData.items;
      if (!items) return;
      let file = null;
      for (let i = 0; i < items.length; i++) {
        if (items[i].kind === 'file') {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        return;
      }
      this.clipboardFile = file;
      
      // Check if a file input box is currently focused/active
      const activeElement = document.activeElement;
      const isFileInputBoxFocused = activeElement && activeElement.closest('.file-input-box');
      
      // If a specific file field was clicked before AND it's still focused, paste directly into that field
      if (this.currentPasteFieldRef && isFileInputBoxFocused) {
        this.pasteFileToField(this.currentPasteFieldRef, false);
      } else {
        // Otherwise show modal so user can pick the file field
        this.currentPasteFieldRef = null; // Clear any stale reference
        // Refresh file fields grouping before showing modal
        this.collectFileFields();
        this.showPasteModal = true;
      }
      e.preventDefault();
    },
    pasteFileToField(refName, closeModal = true) {
      // Use the global FileInputBox registry to paste file to the selected FileInputBox
      if (window.__globalFileInputRegistry && window.__globalFileInputRegistry[refName] && this.clipboardFile) {
        // Clear the input value first to prevent double uploads
        const fileInputBox = window.__globalFileInputRegistry[refName];
        if (fileInputBox.$refs && fileInputBox.$refs.fileInput) {
          fileInputBox.$refs.fileInput.value = '';
        }
        // Small delay to ensure input is cleared before pasting
        this.$nextTick(() => {
          fileInputBox.pasteFile(this.clipboardFile);
          if (closeModal) {
            this.showPasteModal = false;
          }
          this.clipboardFile = null;
          this.currentPasteFieldRef = null;
        });
      }
    },
    formatFileSize(bytes) {
      if (!bytes) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },
    resolvedColorTabs(factory_product, svg_group) {
      const container = factory_product?.svg_group_color_container
      const svgGroupKey = svg_group?.id // "pattern" | "sleeves"
      const productColors = factory_product?.product_colors || []
    
      if (!container || Object.keys(container).length === 0) {
        return productColors
      }
    
      const matched = container[svgGroupKey]
    
      if (matched) {
        return [
          {
            ...matched,
            json_data: matched.json_data.map(c => ({ ...c })) 
          }
        ]
      }
    
      return productColors
    },
    hasSvgGroupOverride(factory_product, svg_group) {
      return !!factory_product?.svg_group_color_container?.[svg_group?.id]
    }

},
beforeDestroy() {
    window.removeEventListener('paste', this.handleGlobalPaste);
    document.removeEventListener('click', this.handleDocumentClick);
  },
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=PT+Sans+Narrow:wght@400;700&display=swap");
* {
  -webkit-print-color-adjust: exact !important; /*Chrome, Safari */
  -moz-print-color-adjust: exact !important; /*Firefox*/
  print-color-adjust: exact !important; /*Standard property*/
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

html {
  margin: 0;
}

html,
body,
table {
  font-size: 11pt;
  font-family: "PT Sans Narrow", sans-serif;
}

body {
  margin: 0.2in;
  padding: 0;
  counter-reset: page;
}

.roster-container {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  font-size: 10pt;
  overflow: hidden;
}

.cell {
  padding: 4px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #eee;
  font-size: 10pt;
}

/* Header Styling */
.roster-header {
  display: grid;
  grid-template-columns: 1fr;
  border-bottom: 1px solid #ccc;
  background: #f5f5f5;
  gap: 0;
}
.roster-header.half-grid{
  grid-template-columns: repeat(2, 1fr);
}

.header-inner{
  display: grid;
  font-weight: 600;
  text-align: center;
  border-top: 1px solid #ccc;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
  grid-template-columns: 35% 8% 18% 8% 9% 9% 6%;
  
}

/* This handles 2 panels side-by-side */
.roster-body {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
}
.roster-body.half-grid{
  grid-template-columns: repeat(2, 1fr);
}


/* Each panel is half width */
.roster-row {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 35% 8% 18% 8% 9% 9% 6%;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
  padding: 4px 0;
}

/* remove right border on right-side panel */
.roster-row:nth-child(2n) {
  border-right: none;
}
/* 
.cell {
  padding: 4px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #eee;
}

.cell:last-child {
  border-right: none;
} */

.form-control {
  width: 100%;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 10pt;
}

.roster-footer {
  padding: 8px;
  border-top: 1px solid #ddd;
  text-align: right;
}


/* Responsive stack panels vertically */
@media (max-width: 768px) {
  .roster-row {
    flex: 0 0 100%;
    max-width: 100%;
    border-right: none;
  }
}

.page {
  counter-increment: page;
}

.page_count::after {
  display: inline-block;
}

.d-flex {
  display: flex !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-start {
  align-items: start !important;
}

.flex-wrap {
  flex-wrap: wrap;
}

.w-20 {
  width: 20% !important;
}

.w-80 {
  width: 80% !important;
}

.w-30 {
  width: 30% !important;
}

.w-70 {
  width: 70% !important;
}

.w-40 {
  width: 40% !important;
}

.w-60 {
  width: 60% !important;
}

.w-35 {
  width: 35% !important;
}

.w-65 {
  width: 65% !important;
}

.w-15 {
  width: 15% !important;
}

.w-100 {
  width: 100% !important;
}

.w-fit {
  width: fit-content !important;
}
.w-100-no-padding {
  width: calc(100% - 0.2in);
}

.page-break-after {
  page-break-after: always;
}

.page-break-before {
  page-break-before: always;
}

.page-break-inside {
  page-break-inside: always;
}

.no-page-break-inside {
  page-break-inside: avoid;
}

.fixed-table {
  table-layout: fixed !important;
}

.bg-gray-light {
  background-color: #ddd !important;
  color: #000;
}

table tr th,
table tr td {
  vertical-align: top;
}

.wrap-td tr td,
.wrap-th tr th,
.wrap-table tr td,
.wrap-table tr th {
  word-break: break-all;
  word-wrap: break-word;
}

.table-border {
  border-collapse: collapse;
}

.table-border td,
.table-border th {
  border: 1pt solid #777;
  padding: 2pt 5pt;
}

.table-border.condensed td,
.table-border.condensed th {
  border: 1pt solid #777;
  padding: 2pt 3pt;
}

.compact-table td,
.compact-table th {
  padding: 1pt 3pt;
}

.table-alter tr:nth-child(even) {
  background-color: #f2f2f2;
}

.table-border tr:hover {
  background-color: #ddd;
}

.table-border th {
  padding-top: 5pt;
  padding-bottom: 5pt;
  text-align: left;
  background-color: #ddd;
}

.v-align-top {
  vertical-align: top !important;
}

.color-box {
  height: 8pt;
  width: 10pt;
  border: 1pt solid #999;
  flex-shrink: 0;
  margin-top: 2pt;
}

.colors {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
}

.colors .color-box {
  height: 25px;
  width: 25px;
  cursor: pointer;
}

.colors .color-box.rounded {
  border-radius: 100px !important;
}

.logos img {
  max-width: 100%;
  max-height: 100%;
  margin-top: 5pt;
}

/* .logos > tbody > tr > td {
  width: 20%;
} */

.logos > tbody > tr > td > div:first-child > div:nth-child(2) {
  height: 70pt;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page > thead > tr > th {
  padding-top: 11pt;
}

.roster-table tr td:first-child {
  word-wrap: break-word;
  word-break: break-all;
}

/* Paste Modal Styles */
.paste-modal-content {
  color: #000000;
}

.paste-modal-content .file-info-box {
  background-color: #e5e7eb;
  padding: 10px 15px;
  border-radius: 4px;
  color: #000000;
}

.paste-modal-accordion .card {
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden;
  background-color: #ffffff;
}

.paste-accordion-header {
  background-color: #e5e7eb !important;
  border-bottom: 1px solid #d1d5db;
  padding: 12px 15px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.paste-accordion-header:hover {
  background-color: #d1d5db !important;
}

.paste-modal-accordion .btn-link {
  font-weight: 500;
  color: #000000 !important;
  transition: none;
}

.paste-modal-accordion .btn-link:hover {
  text-decoration: none;
  color: #000000 !important;
}

.paste-modal-accordion .btn-link:focus {
  box-shadow: none;
  color: #000000 !important;
}

.arrow-icon {
  font-size: 18px;
  color: #000000;
  transition: transform 0.3s ease;
  display: inline-block;
}

.arrow-right {
  transform: rotate(0deg);
}

.arrow-down {
  transform: rotate(90deg);
}

.paste-card-body {
  padding: 15px;
  background-color: #ffffff;
}

.paste-field-btn {
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  color: #000000;
  border-radius: 4px;
  padding: 10px 15px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.paste-field-btn:hover {
  background-color: #f3f4f6;
  border-color: #9ca3af;
  color: #000000;
}

.paste-field-btn:active {
  background-color: #e5e7eb;
  border-color: #9ca3af;
}

.paste-field-btn:focus {
  box-shadow: 0 0 0 0.2rem rgba(229, 231, 235, 0.5);
  outline: none;
}

/* Modal header styling */
::v-deep .modal-header {
  background-color: #e5e7eb;
  border-bottom: 1px solid #d1d5db;
}

::v-deep .modal-title {
  color: #000000;
  font-weight: 600;
}

::v-deep .modal-body {
  background-color: #ffffff;
  color: #000000;
}

.text-details-table tbody tr td:nth-child(2) {
  letter-spacing: -0.5pt;
}

.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  &.absolute {
    position: absolute;
  }
}

.loader {
  position: absolute;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

table,
tr,
th,
td {
  color: #333;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.custom_logo_grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}
.faded_image{
  filter: brightness(40%);
}
</style>
